var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1208.19,
    height: 196.054,
    viewBox: "0 0 1208.19 196.054",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2465",
    "data-name": "Rect\\xE1ngulo 2465",
    width: 86.128,
    height: 35.76,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2581",
    "data-name": "Rect\\xE1ngulo 2581",
    width: 10.163,
    height: 15.133,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2582",
    "data-name": "Rect\\xE1ngulo 2582",
    width: 75.099,
    height: 11.187,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2583",
    "data-name": "Rect\\xE1ngulo 2583",
    width: 41.848,
    height: 11.187,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2584",
    "data-name": "Rect\\xE1ngulo 2584",
    width: 26.816,
    height: 12.795,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2586",
    "data-name": "Rect\\xE1ngulo 2586",
    width: 10.164,
    height: 15.133,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2587",
    "data-name": "Rect\\xE1ngulo 2587",
    width: 63.62,
    height: 8.475,
    fill: "#699dee"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2588",
    "data-name": "Rect\\xE1ngulo 2588",
    width: 45.681,
    height: 66.04,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2589",
    "data-name": "Rect\\xE1ngulo 2589",
    width: 18.006,
    height: 3.033,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2590",
    "data-name": "Rect\\xE1ngulo 2590",
    width: 1.307,
    height: 1.306,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2591",
    "data-name": "Rect\\xE1ngulo 2591",
    width: 8.426,
    height: 8.426,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2596",
    "data-name": "Rect\\xE1ngulo 2596",
    width: 28.547,
    height: 25.394,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2597",
    "data-name": "Rect\\xE1ngulo 2597",
    width: 5.123,
    height: 2.859,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "footer",
    transform: "translate(-395 -648.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ilus",
    transform: "translate(-713 193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1725",
    "data-name": "Trazado 1725",
    d: "M355.517,169.444S401.4,176.891,416,148.717c18.948-36.552-19.981-64.268-49.837-59.1-65.059,11.252-64.244-154.938-152.414-60.419C190.426,54.2,158.985,9.35,120.921,64.7c-8.9,12.936-63.263-12.067-90.321-1.829C-22.354,82.911,1.859,169.782,39.7,170.123s315.821-.679,315.821-.679",
    transform: "translate(1108 481.018)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4039",
    "data-name": "Grupo 4039",
    transform: "translate(684.419 499.299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4038",
    "data-name": "Grupo 4038",
    transform: "translate(474.543 -44)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4040",
    "data-name": "Grupo 4040",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4036",
    "data-name": "Grupo 4036"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4041",
    "data-name": "Grupo 4041",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1469",
    "data-name": "Trazado 1469",
    d: "M1255.1,378.372,1042.618,414.5l-15.866-19.025,184.191-66.966c21.488,15.961,29.731,41.071,44.154,49.861",
    transform: "translate(-910.112 -277.079)",
    fill: "#f8fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1470",
    "data-name": "Trazado 1470",
    d: "M631.041,360.24,420.78,428c6.194-4.515-8.05-28.994.312-37.117Z",
    transform: "translate(-396.992 -303.84)",
    fill: "#f8fbff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1471",
    "data-name": "Trazado 1471",
    d: "M1914.532,287.245a5.068,5.068,0,1,0,5.068,5.068,5.067,5.067,0,0,0-5.068-5.068",
    transform: "translate(-1654.623 -242.273)",
    fill: "#f8fbff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2313",
    "data-name": "Rect\\xE1ngulo 2313",
    width: 23.99,
    height: 116.661,
    transform: "translate(194.312 61.512)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2314",
    "data-name": "Rect\\xE1ngulo 2314",
    width: 23.99,
    height: 116.661,
    transform: "translate(199.7 61.512)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2315",
    "data-name": "Rect\\xE1ngulo 2315",
    width: 23.984,
    height: 6.741,
    transform: "translate(199.706 61.481)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2316",
    "data-name": "Rect\\xE1ngulo 2316",
    width: 23.984,
    height: 6.741,
    transform: "translate(199.706 76.102)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2317",
    "data-name": "Rect\\xE1ngulo 2317",
    width: 23.984,
    height: 6.741,
    transform: "translate(199.706 90.723)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2318",
    "data-name": "Rect\\xE1ngulo 2318",
    width: 23.984,
    height: 6.741,
    transform: "translate(199.706 105.344)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2319",
    "data-name": "Rect\\xE1ngulo 2319",
    width: 23.984,
    height: 6.741,
    transform: "translate(199.706 119.965)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2320",
    "data-name": "Rect\\xE1ngulo 2320",
    width: 23.984,
    height: 6.741,
    transform: "translate(199.706 134.586)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2321",
    "data-name": "Rect\\xE1ngulo 2321",
    width: 23.984,
    height: 6.741,
    transform: "translate(199.706 149.207)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2322",
    "data-name": "Rect\\xE1ngulo 2322",
    width: 23.984,
    height: 6.741,
    transform: "translate(199.706 163.828)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2323",
    "data-name": "Rect\\xE1ngulo 2323",
    width: 23.99,
    height: 100.153,
    transform: "translate(232.662 78.02)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2324",
    "data-name": "Rect\\xE1ngulo 2324",
    width: 23.99,
    height: 100.153,
    transform: "translate(238.05 78.02)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2325",
    "data-name": "Rect\\xE1ngulo 2325",
    width: 23.984,
    height: 5.787,
    transform: "translate(238.056 77.993)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2326",
    "data-name": "Rect\\xE1ngulo 2326",
    width: 23.984,
    height: 5.787,
    transform: "translate(238.056 90.545)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2327",
    "data-name": "Rect\\xE1ngulo 2327",
    width: 23.984,
    height: 5.787,
    transform: "translate(238.056 103.097)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2328",
    "data-name": "Rect\\xE1ngulo 2328",
    width: 23.984,
    height: 5.787,
    transform: "translate(238.056 115.649)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2329",
    "data-name": "Rect\\xE1ngulo 2329",
    width: 23.984,
    height: 5.787,
    transform: "translate(238.056 128.201)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2330",
    "data-name": "Rect\\xE1ngulo 2330",
    width: 23.984,
    height: 5.787,
    transform: "translate(238.056 140.753)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2331",
    "data-name": "Rect\\xE1ngulo 2331",
    width: 23.984,
    height: 5.787,
    transform: "translate(238.056 153.305)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2332",
    "data-name": "Rect\\xE1ngulo 2332",
    width: 23.984,
    height: 5.787,
    transform: "translate(238.056 165.858)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2333",
    "data-name": "Rect\\xE1ngulo 2333",
    width: 10.046,
    height: 14.649,
    transform: "translate(181.328 174.595)",
    fill: "#dceaf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1472",
    "data-name": "Trazado 1472",
    d: "M665.1,579.015v40.671H558.681l-.725-.007-27.158-.255-.082-.141-.159-.276c-.02-.037-.042-.075-.066-.116-.081-.144-.172-.307-.274-.493-.124-.226-.263-.484-.417-.771h0c-.571-1.071-1.329-2.556-2.189-4.4q-.424-.908-.878-1.933c-.12-.272-.241-.549-.364-.832h0q-.178-.41-.357-.838l-.012-.028q-.123-.293-.249-.6c-.087-.206-.173-.415-.26-.627-.444-1.092-.9-2.252-1.351-3.475l-.036-.1h0q-.444-1.2-.883-2.478-.242-.7-.479-1.425c-.009-.029-.02-.058-.029-.09-.07-.214-.139-.428-.209-.645-.058-.182-.116-.365-.173-.549q-.178-.568-.355-1.146-.226-.744-.447-1.509-.3-1.037-.582-2.11-.085-.321-.169-.645-.25-.97-.489-1.963-.077-.319-.151-.64c-.032-.132-.062-.264-.092-.4q-.359-1.573-.678-3.2-.351-1.8-.643-3.661-.268-1.72-.479-3.492-.2-1.672-.336-3.383c-.217-2.669-.316-5.41-.274-8.2a76.368,76.368,0,0,1,1.678-14.952c.04-.185.081-.369.122-.554q.406-1.812.914-3.63.387-1.386.837-2.775.327-1.006.688-2.014.817-2.281,1.818-4.56h.568v-1.261a76.4,76.4,0,0,1,16.6-22.933l.427-.41h.445v15.557H555.5v-25.35H570.7v16.456h3.464V503.186h15.193v36.836h19.214V561.5h7.179v5.411h16.491v-9.318H641.7v-25.32h11.7v46.741Z",
    transform: "translate(-480.699 -424.405)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2334",
    "data-name": "Rect\\xE1ngulo 2334",
    width: 15.201,
    height: 3.753,
    transform: "translate(93.46 81.267)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2335",
    "data-name": "Rect\\xE1ngulo 2335",
    width: 15.201,
    height: 3.753,
    transform: "translate(93.46 88.318)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2336",
    "data-name": "Rect\\xE1ngulo 2336",
    width: 15.201,
    height: 3.753,
    transform: "translate(93.46 94.661)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2337",
    "data-name": "Rect\\xE1ngulo 2337",
    width: 15.201,
    height: 3.753,
    transform: "translate(74.807 94.661)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2338",
    "data-name": "Rect\\xE1ngulo 2338",
    width: 15.201,
    height: 3.753,
    transform: "translate(74.807 88.318)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2339",
    "data-name": "Rect\\xE1ngulo 2339",
    width: 15.201,
    height: 3.753,
    transform: "translate(74.807 81.984)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2340",
    "data-name": "Rect\\xE1ngulo 2340",
    width: 33.858,
    height: 3.753,
    transform: "translate(74.803 100.812)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2341",
    "data-name": "Rect\\xE1ngulo 2341",
    width: 33.858,
    height: 3.753,
    transform: "translate(74.803 106.963)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2342",
    "data-name": "Rect\\xE1ngulo 2342",
    width: 11.798,
    height: 5.793,
    transform: "translate(160.897 107.872)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2343",
    "data-name": "Rect\\xE1ngulo 2343",
    width: 11.798,
    height: 5.793,
    transform: "translate(160.897 116.487)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2344",
    "data-name": "Rect\\xE1ngulo 2344",
    width: 11.798,
    height: 5.793,
    transform: "translate(160.897 125.103)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2345",
    "data-name": "Rect\\xE1ngulo 2345",
    width: 11.798,
    height: 5.794,
    transform: "translate(160.897 134.134)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2346",
    "data-name": "Rect\\xE1ngulo 2346",
    width: 11.798,
    height: 5.794,
    transform: "translate(160.897 142.886)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2347",
    "data-name": "Rect\\xE1ngulo 2347",
    width: 11.798,
    height: 5.793,
    transform: "translate(160.897 151.637)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2348",
    "data-name": "Rect\\xE1ngulo 2348",
    width: 11.798,
    height: 5.793,
    transform: "translate(160.897 160.793)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2349",
    "data-name": "Rect\\xE1ngulo 2349",
    width: 33.858,
    height: 2.383,
    transform: "translate(74.803 112.973)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2350",
    "data-name": "Rect\\xE1ngulo 2350",
    width: 4.35,
    height: 25.317,
    transform: "translate(156.71 107.872)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2351",
    "data-name": "Rect\\xE1ngulo 2351",
    width: 8.751,
    height: 9.318,
    transform: "translate(142.786 133.189)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1473",
    "data-name": "Trazado 1473",
    d: "M743.293,523.648V527.4l0,15.074v6.51h-3.016V523.947l.406-.3Z",
    transform: "translate(-668.486 -441.664)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2352",
    "data-name": "Rect\\xE1ngulo 2352",
    width: 1.854,
    height: 19.634,
    transform: "translate(91.606 78.781)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3998",
    "data-name": "Grupo 3998",
    transform: "translate(38.6 119.312)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3997",
    "data-name": "Grupo 3997"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3996",
    "data-name": "Grupo 3996",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2353",
    "data-name": "Rect\\xE1ngulo 2353",
    width: 2.575,
    height: 3.63,
    transform: "translate(83.552 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2354",
    "data-name": "Rect\\xE1ngulo 2354",
    width: 2.576,
    height: 3.63,
    transform: "translate(78.735 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2355",
    "data-name": "Rect\\xE1ngulo 2355",
    width: 2.575,
    height: 3.63,
    transform: "translate(74.027 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2356",
    "data-name": "Rect\\xE1ngulo 2356",
    width: 2.575,
    height: 3.63,
    transform: "translate(69.563 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2357",
    "data-name": "Rect\\xE1ngulo 2357",
    width: 2.575,
    height: 3.63,
    transform: "translate(65.013 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2358",
    "data-name": "Rect\\xE1ngulo 2358",
    width: 2.575,
    height: 3.63,
    transform: "translate(60.411 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2359",
    "data-name": "Rect\\xE1ngulo 2359",
    width: 2.575,
    height: 3.63,
    transform: "translate(55.594 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2360",
    "data-name": "Rect\\xE1ngulo 2360",
    width: 2.575,
    height: 3.63,
    transform: "translate(50.886 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2361",
    "data-name": "Rect\\xE1ngulo 2361",
    width: 2.575,
    height: 3.63,
    transform: "translate(46.422 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2362",
    "data-name": "Rect\\xE1ngulo 2362",
    width: 2.575,
    height: 3.63,
    transform: "translate(41.872 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2363",
    "data-name": "Rect\\xE1ngulo 2363",
    width: 2.576,
    height: 3.63,
    transform: "translate(37.13 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2364",
    "data-name": "Rect\\xE1ngulo 2364",
    width: 2.575,
    height: 3.63,
    transform: "translate(32.314 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2365",
    "data-name": "Rect\\xE1ngulo 2365",
    width: 2.575,
    height: 3.63,
    transform: "translate(27.605 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2366",
    "data-name": "Rect\\xE1ngulo 2366",
    width: 2.575,
    height: 3.63,
    transform: "translate(23.141 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2367",
    "data-name": "Rect\\xE1ngulo 2367",
    width: 2.575,
    height: 3.63,
    transform: "translate(18.591 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2368",
    "data-name": "Rect\\xE1ngulo 2368",
    width: 2.576,
    height: 3.63,
    transform: "translate(13.989 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2369",
    "data-name": "Rect\\xE1ngulo 2369",
    width: 2.575,
    height: 3.63,
    transform: "translate(9.173 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2370",
    "data-name": "Rect\\xE1ngulo 2370",
    width: 2.575,
    height: 3.63,
    transform: "translate(4.464 0)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1474",
    "data-name": "Trazado 1474",
    d: "M541.051,772.392v2.014h-.688q.327-1.006.688-2.014",
    transform: "translate(-538.474 -770.775)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2371",
    "data-name": "Rect\\xE1ngulo 2371",
    width: 2.575,
    height: 3.63,
    transform: "translate(83.552 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2372",
    "data-name": "Rect\\xE1ngulo 2372",
    width: 2.576,
    height: 3.63,
    transform: "translate(78.735 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2373",
    "data-name": "Rect\\xE1ngulo 2373",
    width: 2.575,
    height: 3.63,
    transform: "translate(74.027 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2374",
    "data-name": "Rect\\xE1ngulo 2374",
    width: 2.575,
    height: 3.63,
    transform: "translate(69.563 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2375",
    "data-name": "Rect\\xE1ngulo 2375",
    width: 2.575,
    height: 3.63,
    transform: "translate(65.013 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2376",
    "data-name": "Rect\\xE1ngulo 2376",
    width: 2.575,
    height: 3.63,
    transform: "translate(60.411 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2377",
    "data-name": "Rect\\xE1ngulo 2377",
    width: 2.575,
    height: 3.63,
    transform: "translate(55.594 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2378",
    "data-name": "Rect\\xE1ngulo 2378",
    width: 2.575,
    height: 3.63,
    transform: "translate(50.886 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2379",
    "data-name": "Rect\\xE1ngulo 2379",
    width: 2.575,
    height: 3.63,
    transform: "translate(46.422 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2380",
    "data-name": "Rect\\xE1ngulo 2380",
    width: 2.575,
    height: 3.63,
    transform: "translate(41.872 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2381",
    "data-name": "Rect\\xE1ngulo 2381",
    width: 2.576,
    height: 3.63,
    transform: "translate(37.13 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2382",
    "data-name": "Rect\\xE1ngulo 2382",
    width: 2.575,
    height: 3.63,
    transform: "translate(32.314 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2383",
    "data-name": "Rect\\xE1ngulo 2383",
    width: 2.575,
    height: 3.63,
    transform: "translate(27.605 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2384",
    "data-name": "Rect\\xE1ngulo 2384",
    width: 2.575,
    height: 3.63,
    transform: "translate(23.141 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2385",
    "data-name": "Rect\\xE1ngulo 2385",
    width: 2.575,
    height: 3.63,
    transform: "translate(18.591 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2386",
    "data-name": "Rect\\xE1ngulo 2386",
    width: 2.576,
    height: 3.63,
    transform: "translate(13.989 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2387",
    "data-name": "Rect\\xE1ngulo 2387",
    width: 2.575,
    height: 3.63,
    transform: "translate(9.173 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2388",
    "data-name": "Rect\\xE1ngulo 2388",
    width: 2.575,
    height: 3.63,
    transform: "translate(4.464 6.406)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1475",
    "data-name": "Trazado 1475",
    d: "M531.621,802.978v3.63h-2.438q.406-1.812.914-3.63Z",
    transform: "translate(-529.045 -796.572)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2389",
    "data-name": "Rect\\xE1ngulo 2389",
    width: 2.575,
    height: 3.63,
    transform: "translate(83.552 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2390",
    "data-name": "Rect\\xE1ngulo 2390",
    width: 2.576,
    height: 3.63,
    transform: "translate(78.735 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2391",
    "data-name": "Rect\\xE1ngulo 2391",
    width: 2.575,
    height: 3.63,
    transform: "translate(74.027 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2392",
    "data-name": "Rect\\xE1ngulo 2392",
    width: 2.575,
    height: 3.63,
    transform: "translate(69.563 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2393",
    "data-name": "Rect\\xE1ngulo 2393",
    width: 2.575,
    height: 3.63,
    transform: "translate(65.013 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2394",
    "data-name": "Rect\\xE1ngulo 2394",
    width: 2.575,
    height: 3.63,
    transform: "translate(60.411 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2395",
    "data-name": "Rect\\xE1ngulo 2395",
    width: 2.575,
    height: 3.63,
    transform: "translate(55.594 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2396",
    "data-name": "Rect\\xE1ngulo 2396",
    width: 2.575,
    height: 3.63,
    transform: "translate(50.886 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2397",
    "data-name": "Rect\\xE1ngulo 2397",
    width: 2.575,
    height: 3.63,
    transform: "translate(46.422 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2398",
    "data-name": "Rect\\xE1ngulo 2398",
    width: 2.575,
    height: 3.63,
    transform: "translate(41.872 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2399",
    "data-name": "Rect\\xE1ngulo 2399",
    width: 2.576,
    height: 3.63,
    transform: "translate(37.13 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2400",
    "data-name": "Rect\\xE1ngulo 2400",
    width: 2.575,
    height: 3.63,
    transform: "translate(32.314 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2401",
    "data-name": "Rect\\xE1ngulo 2401",
    width: 2.575,
    height: 3.63,
    transform: "translate(27.605 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2402",
    "data-name": "Rect\\xE1ngulo 2402",
    width: 2.575,
    height: 3.63,
    transform: "translate(23.141 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2403",
    "data-name": "Rect\\xE1ngulo 2403",
    width: 2.575,
    height: 3.63,
    transform: "translate(18.591 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2404",
    "data-name": "Rect\\xE1ngulo 2404",
    width: 2.576,
    height: 3.63,
    transform: "translate(13.989 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2405",
    "data-name": "Rect\\xE1ngulo 2405",
    width: 2.575,
    height: 3.63,
    transform: "translate(9.173 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2406",
    "data-name": "Rect\\xE1ngulo 2406",
    width: 2.575,
    height: 3.63,
    transform: "translate(4.464 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2407",
    "data-name": "Rect\\xE1ngulo 2407",
    width: 2.576,
    height: 3.63,
    transform: "translate(0 12.714)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2408",
    "data-name": "Rect\\xE1ngulo 2408",
    width: 2.575,
    height: 3.63,
    transform: "translate(83.552 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2409",
    "data-name": "Rect\\xE1ngulo 2409",
    width: 2.576,
    height: 3.63,
    transform: "translate(78.735 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2410",
    "data-name": "Rect\\xE1ngulo 2410",
    width: 2.575,
    height: 3.63,
    transform: "translate(74.027 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2411",
    "data-name": "Rect\\xE1ngulo 2411",
    width: 2.575,
    height: 3.63,
    transform: "translate(69.563 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2412",
    "data-name": "Rect\\xE1ngulo 2412",
    width: 2.575,
    height: 3.63,
    transform: "translate(65.013 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2413",
    "data-name": "Rect\\xE1ngulo 2413",
    width: 2.575,
    height: 3.63,
    transform: "translate(60.411 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2414",
    "data-name": "Rect\\xE1ngulo 2414",
    width: 2.575,
    height: 3.63,
    transform: "translate(55.594 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2415",
    "data-name": "Rect\\xE1ngulo 2415",
    width: 2.575,
    height: 3.63,
    transform: "translate(50.886 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2416",
    "data-name": "Rect\\xE1ngulo 2416",
    width: 2.575,
    height: 3.63,
    transform: "translate(46.422 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2417",
    "data-name": "Rect\\xE1ngulo 2417",
    width: 2.575,
    height: 3.63,
    transform: "translate(41.872 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2418",
    "data-name": "Rect\\xE1ngulo 2418",
    width: 2.576,
    height: 3.63,
    transform: "translate(37.13 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2419",
    "data-name": "Rect\\xE1ngulo 2419",
    width: 2.575,
    height: 3.63,
    transform: "translate(32.314 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2420",
    "data-name": "Rect\\xE1ngulo 2420",
    width: 2.575,
    height: 3.63,
    transform: "translate(27.605 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2421",
    "data-name": "Rect\\xE1ngulo 2421",
    width: 2.575,
    height: 3.63,
    transform: "translate(23.141 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2422",
    "data-name": "Rect\\xE1ngulo 2422",
    width: 2.575,
    height: 3.63,
    transform: "translate(18.591 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2423",
    "data-name": "Rect\\xE1ngulo 2423",
    width: 2.576,
    height: 3.63,
    transform: "translate(13.989 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2424",
    "data-name": "Rect\\xE1ngulo 2424",
    width: 2.575,
    height: 3.63,
    transform: "translate(9.173 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2425",
    "data-name": "Rect\\xE1ngulo 2425",
    width: 2.575,
    height: 3.63,
    transform: "translate(4.464 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2426",
    "data-name": "Rect\\xE1ngulo 2426",
    width: 2.576,
    height: 3.63,
    transform: "translate(0 19.416)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2427",
    "data-name": "Rect\\xE1ngulo 2427",
    width: 2.575,
    height: 3.63,
    transform: "translate(83.552 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2428",
    "data-name": "Rect\\xE1ngulo 2428",
    width: 2.576,
    height: 3.63,
    transform: "translate(78.735 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2429",
    "data-name": "Rect\\xE1ngulo 2429",
    width: 2.575,
    height: 3.63,
    transform: "translate(74.027 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2430",
    "data-name": "Rect\\xE1ngulo 2430",
    width: 2.575,
    height: 3.63,
    transform: "translate(69.563 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2431",
    "data-name": "Rect\\xE1ngulo 2431",
    width: 2.575,
    height: 3.63,
    transform: "translate(65.013 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2432",
    "data-name": "Rect\\xE1ngulo 2432",
    width: 2.575,
    height: 3.63,
    transform: "translate(60.411 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2433",
    "data-name": "Rect\\xE1ngulo 2433",
    width: 2.575,
    height: 3.63,
    transform: "translate(55.594 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2434",
    "data-name": "Rect\\xE1ngulo 2434",
    width: 2.575,
    height: 3.63,
    transform: "translate(50.886 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2435",
    "data-name": "Rect\\xE1ngulo 2435",
    width: 2.575,
    height: 3.63,
    transform: "translate(46.422 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2436",
    "data-name": "Rect\\xE1ngulo 2436",
    width: 2.575,
    height: 3.63,
    transform: "translate(41.872 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2437",
    "data-name": "Rect\\xE1ngulo 2437",
    width: 2.576,
    height: 3.63,
    transform: "translate(37.13 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2438",
    "data-name": "Rect\\xE1ngulo 2438",
    width: 2.575,
    height: 3.63,
    transform: "translate(32.314 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2439",
    "data-name": "Rect\\xE1ngulo 2439",
    width: 2.575,
    height: 3.63,
    transform: "translate(27.605 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2440",
    "data-name": "Rect\\xE1ngulo 2440",
    width: 2.575,
    height: 3.63,
    transform: "translate(23.141 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2441",
    "data-name": "Rect\\xE1ngulo 2441",
    width: 2.575,
    height: 3.63,
    transform: "translate(18.591 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2442",
    "data-name": "Rect\\xE1ngulo 2442",
    width: 2.576,
    height: 3.63,
    transform: "translate(13.989 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2443",
    "data-name": "Rect\\xE1ngulo 2443",
    width: 2.575,
    height: 3.63,
    transform: "translate(9.173 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2444",
    "data-name": "Rect\\xE1ngulo 2444",
    width: 2.575,
    height: 3.63,
    transform: "translate(4.464 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2445",
    "data-name": "Rect\\xE1ngulo 2445",
    width: 2.576,
    height: 3.63,
    transform: "translate(0 25.822)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2446",
    "data-name": "Rect\\xE1ngulo 2446",
    width: 2.575,
    height: 3.63,
    transform: "translate(83.552 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2447",
    "data-name": "Rect\\xE1ngulo 2447",
    width: 2.576,
    height: 3.63,
    transform: "translate(78.735 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2448",
    "data-name": "Rect\\xE1ngulo 2448",
    width: 2.575,
    height: 3.63,
    transform: "translate(74.027 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2449",
    "data-name": "Rect\\xE1ngulo 2449",
    width: 2.575,
    height: 3.63,
    transform: "translate(69.563 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2450",
    "data-name": "Rect\\xE1ngulo 2450",
    width: 2.575,
    height: 3.63,
    transform: "translate(65.013 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2451",
    "data-name": "Rect\\xE1ngulo 2451",
    width: 2.575,
    height: 3.63,
    transform: "translate(60.411 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2452",
    "data-name": "Rect\\xE1ngulo 2452",
    width: 2.575,
    height: 3.63,
    transform: "translate(55.594 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2453",
    "data-name": "Rect\\xE1ngulo 2453",
    width: 2.575,
    height: 3.63,
    transform: "translate(50.886 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2454",
    "data-name": "Rect\\xE1ngulo 2454",
    width: 2.575,
    height: 3.63,
    transform: "translate(46.422 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2455",
    "data-name": "Rect\\xE1ngulo 2455",
    width: 2.575,
    height: 3.63,
    transform: "translate(41.872 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2456",
    "data-name": "Rect\\xE1ngulo 2456",
    width: 2.576,
    height: 3.63,
    transform: "translate(37.13 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2457",
    "data-name": "Rect\\xE1ngulo 2457",
    width: 2.575,
    height: 3.63,
    transform: "translate(32.314 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2458",
    "data-name": "Rect\\xE1ngulo 2458",
    width: 2.575,
    height: 3.63,
    transform: "translate(27.605 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2459",
    "data-name": "Rect\\xE1ngulo 2459",
    width: 2.575,
    height: 3.63,
    transform: "translate(23.141 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2460",
    "data-name": "Rect\\xE1ngulo 2460",
    width: 2.575,
    height: 3.63,
    transform: "translate(18.591 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2461",
    "data-name": "Rect\\xE1ngulo 2461",
    width: 2.576,
    height: 3.63,
    transform: "translate(13.989 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2462",
    "data-name": "Rect\\xE1ngulo 2462",
    width: 2.575,
    height: 3.63,
    transform: "translate(9.173 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2463",
    "data-name": "Rect\\xE1ngulo 2463",
    width: 2.575,
    height: 3.63,
    transform: "translate(4.464 32.129)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2464",
    "data-name": "Rect\\xE1ngulo 2464",
    width: 2.576,
    height: 3.63,
    transform: "translate(0 32.129)",
    fill: "#c4d9ed"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2466",
    "data-name": "Rect\\xE1ngulo 2466",
    width: 59.695,
    height: 32.204,
    transform: "translate(83.091 162.815)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2467",
    "data-name": "Rect\\xE1ngulo 2467",
    width: 59.695,
    height: 16.102,
    transform: "translate(128.357 178.917)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1476",
    "data-name": "Trazado 1476",
    d: "M573.344,1071.973v27.187H545.138l-.082-.142-.159-.276c-.02-.037-.042-.076-.066-.117-.081-.144-.172-.307-.274-.493-.124-.226-.263-.484-.416-.771h0c-.571-1.071-1.329-2.556-2.19-4.4q-.424-.908-.878-1.933c-.12-.272-.24-.548-.364-.831h0q-.179-.411-.357-.838l-.012-.028q-.123-.293-.249-.6c-.087-.206-.173-.415-.26-.627-.444-1.092-.9-2.252-1.351-3.474l-.036-.1h0q-.445-1.2-.883-2.478-.242-.7-.479-1.425c-.009-.029-.02-.058-.029-.09-.07-.214-.139-.429-.209-.645-.058-.182-.116-.365-.173-.548q-.178-.568-.356-1.147-.226-.744-.447-1.508-.3-1.037-.582-2.11c-.057-.214-.114-.43-.169-.645q-.25-.97-.489-1.963Z",
    transform: "translate(-495.039 -904.14)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2468",
    "data-name": "Rect\\xE1ngulo 2468",
    width: 11.122,
    height: 5.964,
    transform: "translate(127.676 166.586)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2469",
    "data-name": "Rect\\xE1ngulo 2469",
    width: 11.122,
    height: 5.964,
    transform: "translate(113.4 166.586)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2470",
    "data-name": "Rect\\xE1ngulo 2470",
    width: 11.122,
    height: 5.964,
    transform: "translate(99.395 166.586)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2471",
    "data-name": "Rect\\xE1ngulo 2471",
    width: 11.122,
    height: 5.964,
    transform: "translate(85.659 166.586)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2472",
    "data-name": "Rect\\xE1ngulo 2472",
    width: 5.73,
    height: 32.481,
    transform: "translate(77.982 162.815)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2473",
    "data-name": "Rect\\xE1ngulo 2473",
    width: 0.31,
    height: 2.521,
    transform: "translate(170.036 105.35)",
    fill: "#dceaf9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2474",
    "data-name": "Rect\\xE1ngulo 2474",
    width: 0.31,
    height: 2.521,
    transform: "translate(158.888 105.35)",
    fill: "#dceaf9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1477",
    "data-name": "Trazado 1477",
    d: "M521.583,999.2q.208,1.771.479,3.492.289,1.862.642,3.661.318,1.632.678,3.2c.03.132.061.264.093.4.049.214.1.427.151.64q.238.994.489,1.963c.055.215.112.431.169.645q.284,1.073.582,2.11.22.764.447,1.509.176.579.356,1.146c.057.184.115.366.173.549.07.217.139.431.209.645.009.032.02.061.029.09q.238.724.479,1.425.438,1.277.883,2.478h0l.036.1c.452,1.223.907,2.383,1.351,3.475.087.211.173.42.261.627s.167.4.249.6l.012.028V999.2Z",
    transform: "translate(-484.034 -842.759)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1478",
    "data-name": "Trazado 1478",
    d: "M539.541,1067.885v18.023l-.012-.028q-.123-.293-.249-.6c-.087-.206-.173-.416-.26-.627-.444-1.092-.9-2.252-1.351-3.475l-.036-.1h0q-.444-1.2-.883-2.478-.242-.7-.479-1.425c-.009-.029-.02-.058-.029-.09-.07-.214-.139-.428-.209-.645-.058-.183-.116-.365-.173-.549q-.179-.567-.356-1.147-.226-.744-.447-1.508-.3-1.037-.582-2.11-.085-.321-.169-.645-.25-.97-.489-1.963-.077-.32-.151-.64Z",
    transform: "translate(-494.226 -900.692)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1479",
    "data-name": "Trazado 1479",
    d: "M535.389,1044.882v8.96h-4.483q-.3-1.037-.582-2.11c-.057-.214-.114-.43-.169-.645q-.25-.97-.489-1.963c-.052-.213-.1-.426-.151-.64-.032-.132-.062-.264-.092-.4q-.359-1.573-.678-3.2Z",
    transform: "translate(-490.074 -881.291)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1480",
    "data-name": "Trazado 1480",
    d: "M548.567,1119.069v2.709q-.242-.7-.479-1.425c-.009-.029-.02-.058-.029-.09-.07-.214-.139-.428-.209-.645-.058-.183-.116-.365-.173-.549Z",
    transform: "translate(-506.043 -943.863)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2475",
    "data-name": "Rect\\xE1ngulo 2475",
    width: 1.769,
    height: 3.06,
    transform: "translate(40.419 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2476",
    "data-name": "Rect\\xE1ngulo 2476",
    width: 40.987,
    height: 27.565,
    transform: "translate(176.751 167.193)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2477",
    "data-name": "Rect\\xE1ngulo 2477",
    width: 40.987,
    height: 8.959,
    transform: "translate(176.751 163.592)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2478",
    "data-name": "Rect\\xE1ngulo 2478",
    width: 2.105,
    height: 2.967,
    transform: "translate(212.843 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2479",
    "data-name": "Rect\\xE1ngulo 2479",
    width: 2.105,
    height: 2.967,
    transform: "translate(208.906 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2480",
    "data-name": "Rect\\xE1ngulo 2480",
    width: 2.105,
    height: 2.967,
    transform: "translate(205.058 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2481",
    "data-name": "Rect\\xE1ngulo 2481",
    width: 2.105,
    height: 2.967,
    transform: "translate(201.409 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2482",
    "data-name": "Rect\\xE1ngulo 2482",
    width: 2.105,
    height: 2.967,
    transform: "translate(197.69 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2483",
    "data-name": "Rect\\xE1ngulo 2483",
    width: 2.105,
    height: 2.967,
    transform: "translate(193.929 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2484",
    "data-name": "Rect\\xE1ngulo 2484",
    width: 2.105,
    height: 2.967,
    transform: "translate(189.993 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2485",
    "data-name": "Rect\\xE1ngulo 2485",
    width: 2.105,
    height: 2.967,
    transform: "translate(186.144 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2486",
    "data-name": "Rect\\xE1ngulo 2486",
    width: 2.105,
    height: 2.967,
    transform: "translate(182.495 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2487",
    "data-name": "Rect\\xE1ngulo 2487",
    width: 2.105,
    height: 2.967,
    transform: "translate(178.777 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2488",
    "data-name": "Rect\\xE1ngulo 2488",
    width: 2.105,
    height: 2.967,
    transform: "translate(212.843 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2489",
    "data-name": "Rect\\xE1ngulo 2489",
    width: 2.105,
    height: 2.967,
    transform: "translate(208.906 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2490",
    "data-name": "Rect\\xE1ngulo 2490",
    width: 2.105,
    height: 2.967,
    transform: "translate(205.058 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2491",
    "data-name": "Rect\\xE1ngulo 2491",
    width: 2.105,
    height: 2.967,
    transform: "translate(201.409 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2492",
    "data-name": "Rect\\xE1ngulo 2492",
    width: 2.105,
    height: 2.967,
    transform: "translate(197.69 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2493",
    "data-name": "Rect\\xE1ngulo 2493",
    width: 2.105,
    height: 2.967,
    transform: "translate(193.929 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2494",
    "data-name": "Rect\\xE1ngulo 2494",
    width: 2.105,
    height: 2.967,
    transform: "translate(189.993 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2495",
    "data-name": "Rect\\xE1ngulo 2495",
    width: 2.105,
    height: 2.967,
    transform: "translate(186.144 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2496",
    "data-name": "Rect\\xE1ngulo 2496",
    width: 2.105,
    height: 2.967,
    transform: "translate(182.495 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2497",
    "data-name": "Rect\\xE1ngulo 2497",
    width: 2.105,
    height: 2.967,
    transform: "translate(178.777 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2498",
    "data-name": "Rect\\xE1ngulo 2498",
    width: 2.105,
    height: 2.967,
    transform: "translate(212.843 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2499",
    "data-name": "Rect\\xE1ngulo 2499",
    width: 2.105,
    height: 2.967,
    transform: "translate(208.906 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2500",
    "data-name": "Rect\\xE1ngulo 2500",
    width: 2.105,
    height: 2.967,
    transform: "translate(205.058 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2501",
    "data-name": "Rect\\xE1ngulo 2501",
    width: 2.105,
    height: 2.967,
    transform: "translate(201.409 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2502",
    "data-name": "Rect\\xE1ngulo 2502",
    width: 2.105,
    height: 2.967,
    transform: "translate(197.69 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2503",
    "data-name": "Rect\\xE1ngulo 2503",
    width: 2.105,
    height: 2.967,
    transform: "translate(193.929 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2504",
    "data-name": "Rect\\xE1ngulo 2504",
    width: 2.105,
    height: 2.967,
    transform: "translate(189.993 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2505",
    "data-name": "Rect\\xE1ngulo 2505",
    width: 2.105,
    height: 2.967,
    transform: "translate(186.144 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2506",
    "data-name": "Rect\\xE1ngulo 2506",
    width: 2.105,
    height: 2.967,
    transform: "translate(182.495 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2507",
    "data-name": "Rect\\xE1ngulo 2507",
    width: 2.105,
    height: 2.967,
    transform: "translate(178.777 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2508",
    "data-name": "Rect\\xE1ngulo 2508",
    width: 1.769,
    height: 3.06,
    transform: "translate(212.843 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2509",
    "data-name": "Rect\\xE1ngulo 2509",
    width: 1.769,
    height: 3.06,
    transform: "translate(195.281 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2510",
    "data-name": "Rect\\xE1ngulo 2510",
    width: 1.769,
    height: 3.06,
    transform: "translate(181.311 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2511",
    "data-name": "Rect\\xE1ngulo 2511",
    width: 40.987,
    height: 27.565,
    transform: "translate(220.313 167.193)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2512",
    "data-name": "Rect\\xE1ngulo 2512",
    width: 40.987,
    height: 8.959,
    transform: "translate(220.313 163.592)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2513",
    "data-name": "Rect\\xE1ngulo 2513",
    width: 2.105,
    height: 2.967,
    transform: "translate(256.404 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2514",
    "data-name": "Rect\\xE1ngulo 2514",
    width: 2.105,
    height: 2.967,
    transform: "translate(252.468 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2515",
    "data-name": "Rect\\xE1ngulo 2515",
    width: 2.105,
    height: 2.967,
    transform: "translate(248.62 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2516",
    "data-name": "Rect\\xE1ngulo 2516",
    width: 2.105,
    height: 2.967,
    transform: "translate(244.971 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2517",
    "data-name": "Rect\\xE1ngulo 2517",
    width: 2.105,
    height: 2.967,
    transform: "translate(241.252 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2518",
    "data-name": "Rect\\xE1ngulo 2518",
    width: 2.105,
    height: 2.967,
    transform: "translate(237.491 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2519",
    "data-name": "Rect\\xE1ngulo 2519",
    width: 2.105,
    height: 2.967,
    transform: "translate(233.554 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2520",
    "data-name": "Rect\\xE1ngulo 2520",
    width: 2.105,
    height: 2.967,
    transform: "translate(229.706 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2521",
    "data-name": "Rect\\xE1ngulo 2521",
    width: 2.105,
    height: 2.967,
    transform: "translate(226.057 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2522",
    "data-name": "Rect\\xE1ngulo 2522",
    width: 2.105,
    height: 2.967,
    transform: "translate(222.338 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2523",
    "data-name": "Rect\\xE1ngulo 2523",
    width: 2.105,
    height: 2.967,
    transform: "translate(256.404 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2524",
    "data-name": "Rect\\xE1ngulo 2524",
    width: 2.105,
    height: 2.967,
    transform: "translate(252.468 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2525",
    "data-name": "Rect\\xE1ngulo 2525",
    width: 2.105,
    height: 2.967,
    transform: "translate(248.62 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2526",
    "data-name": "Rect\\xE1ngulo 2526",
    width: 2.105,
    height: 2.967,
    transform: "translate(244.971 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2527",
    "data-name": "Rect\\xE1ngulo 2527",
    width: 2.105,
    height: 2.967,
    transform: "translate(241.252 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2528",
    "data-name": "Rect\\xE1ngulo 2528",
    width: 2.105,
    height: 2.967,
    transform: "translate(237.491 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2529",
    "data-name": "Rect\\xE1ngulo 2529",
    width: 2.105,
    height: 2.967,
    transform: "translate(233.554 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2530",
    "data-name": "Rect\\xE1ngulo 2530",
    width: 2.105,
    height: 2.967,
    transform: "translate(229.706 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2531",
    "data-name": "Rect\\xE1ngulo 2531",
    width: 2.105,
    height: 2.967,
    transform: "translate(226.057 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2532",
    "data-name": "Rect\\xE1ngulo 2532",
    width: 2.105,
    height: 2.967,
    transform: "translate(222.338 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2533",
    "data-name": "Rect\\xE1ngulo 2533",
    width: 2.105,
    height: 2.967,
    transform: "translate(256.404 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2534",
    "data-name": "Rect\\xE1ngulo 2534",
    width: 2.105,
    height: 2.967,
    transform: "translate(252.468 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2535",
    "data-name": "Rect\\xE1ngulo 2535",
    width: 2.105,
    height: 2.967,
    transform: "translate(248.62 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2536",
    "data-name": "Rect\\xE1ngulo 2536",
    width: 2.105,
    height: 2.967,
    transform: "translate(244.971 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2537",
    "data-name": "Rect\\xE1ngulo 2537",
    width: 2.105,
    height: 2.967,
    transform: "translate(241.252 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2538",
    "data-name": "Rect\\xE1ngulo 2538",
    width: 2.105,
    height: 2.967,
    transform: "translate(237.491 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2539",
    "data-name": "Rect\\xE1ngulo 2539",
    width: 2.105,
    height: 2.967,
    transform: "translate(233.554 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2540",
    "data-name": "Rect\\xE1ngulo 2540",
    width: 2.105,
    height: 2.967,
    transform: "translate(229.706 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2541",
    "data-name": "Rect\\xE1ngulo 2541",
    width: 2.105,
    height: 2.967,
    transform: "translate(226.057 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2542",
    "data-name": "Rect\\xE1ngulo 2542",
    width: 2.105,
    height: 2.967,
    transform: "translate(222.338 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2543",
    "data-name": "Rect\\xE1ngulo 2543",
    width: 1.769,
    height: 3.06,
    transform: "translate(256.404 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2544",
    "data-name": "Rect\\xE1ngulo 2544",
    width: 1.769,
    height: 3.06,
    transform: "translate(238.843 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2545",
    "data-name": "Rect\\xE1ngulo 2545",
    width: 1.769,
    height: 3.06,
    transform: "translate(224.873 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2546",
    "data-name": "Rect\\xE1ngulo 2546",
    width: 40.987,
    height: 27.565,
    transform: "translate(306.103 167.193)",
    fill: "#d5e7f7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2547",
    "data-name": "Rect\\xE1ngulo 2547",
    width: 40.987,
    height: 8.959,
    transform: "translate(306.103 163.592)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2548",
    "data-name": "Rect\\xE1ngulo 2548",
    width: 2.105,
    height: 2.967,
    transform: "translate(342.194 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2549",
    "data-name": "Rect\\xE1ngulo 2549",
    width: 2.105,
    height: 2.967,
    transform: "translate(338.258 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2550",
    "data-name": "Rect\\xE1ngulo 2550",
    width: 2.105,
    height: 2.967,
    transform: "translate(334.41 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2551",
    "data-name": "Rect\\xE1ngulo 2551",
    width: 2.105,
    height: 2.967,
    transform: "translate(330.761 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2552",
    "data-name": "Rect\\xE1ngulo 2552",
    width: 2.105,
    height: 2.967,
    transform: "translate(327.042 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2553",
    "data-name": "Rect\\xE1ngulo 2553",
    width: 2.105,
    height: 2.967,
    transform: "translate(323.281 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2554",
    "data-name": "Rect\\xE1ngulo 2554",
    width: 2.105,
    height: 2.967,
    transform: "translate(319.344 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2555",
    "data-name": "Rect\\xE1ngulo 2555",
    width: 2.105,
    height: 2.967,
    transform: "translate(315.496 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2556",
    "data-name": "Rect\\xE1ngulo 2556",
    width: 2.105,
    height: 2.967,
    transform: "translate(311.847 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2557",
    "data-name": "Rect\\xE1ngulo 2557",
    width: 2.105,
    height: 2.967,
    transform: "translate(308.128 175.206)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2558",
    "data-name": "Rect\\xE1ngulo 2558",
    width: 2.105,
    height: 2.967,
    transform: "translate(342.194 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2559",
    "data-name": "Rect\\xE1ngulo 2559",
    width: 2.105,
    height: 2.967,
    transform: "translate(338.258 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2560",
    "data-name": "Rect\\xE1ngulo 2560",
    width: 2.105,
    height: 2.967,
    transform: "translate(334.41 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2561",
    "data-name": "Rect\\xE1ngulo 2561",
    width: 2.105,
    height: 2.967,
    transform: "translate(330.761 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2562",
    "data-name": "Rect\\xE1ngulo 2562",
    width: 2.105,
    height: 2.967,
    transform: "translate(327.042 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2563",
    "data-name": "Rect\\xE1ngulo 2563",
    width: 2.105,
    height: 2.967,
    transform: "translate(323.281 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2564",
    "data-name": "Rect\\xE1ngulo 2564",
    width: 2.105,
    height: 2.967,
    transform: "translate(319.344 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2565",
    "data-name": "Rect\\xE1ngulo 2565",
    width: 2.105,
    height: 2.967,
    transform: "translate(315.496 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2566",
    "data-name": "Rect\\xE1ngulo 2566",
    width: 2.105,
    height: 2.967,
    transform: "translate(311.847 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2567",
    "data-name": "Rect\\xE1ngulo 2567",
    width: 2.105,
    height: 2.967,
    transform: "translate(308.128 180.442)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2568",
    "data-name": "Rect\\xE1ngulo 2568",
    width: 2.105,
    height: 2.967,
    transform: "translate(342.194 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2569",
    "data-name": "Rect\\xE1ngulo 2569",
    width: 2.105,
    height: 2.967,
    transform: "translate(338.258 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2570",
    "data-name": "Rect\\xE1ngulo 2570",
    width: 2.105,
    height: 2.967,
    transform: "translate(334.41 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2571",
    "data-name": "Rect\\xE1ngulo 2571",
    width: 2.105,
    height: 2.967,
    transform: "translate(330.761 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2572",
    "data-name": "Rect\\xE1ngulo 2572",
    width: 2.105,
    height: 2.967,
    transform: "translate(327.042 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2573",
    "data-name": "Rect\\xE1ngulo 2573",
    width: 2.105,
    height: 2.967,
    transform: "translate(323.281 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2574",
    "data-name": "Rect\\xE1ngulo 2574",
    width: 2.105,
    height: 2.967,
    transform: "translate(319.344 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2575",
    "data-name": "Rect\\xE1ngulo 2575",
    width: 2.105,
    height: 2.967,
    transform: "translate(315.496 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2576",
    "data-name": "Rect\\xE1ngulo 2576",
    width: 2.105,
    height: 2.967,
    transform: "translate(311.847 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2577",
    "data-name": "Rect\\xE1ngulo 2577",
    width: 2.105,
    height: 2.967,
    transform: "translate(308.128 185.597)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2578",
    "data-name": "Rect\\xE1ngulo 2578",
    width: 1.769,
    height: 3.06,
    transform: "translate(342.194 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2579",
    "data-name": "Rect\\xE1ngulo 2579",
    width: 1.769,
    height: 3.06,
    transform: "translate(324.633 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2580",
    "data-name": "Rect\\xE1ngulo 2580",
    width: 1.769,
    height: 3.06,
    transform: "translate(310.663 166.109)",
    fill: "#adc9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1481",
    "data-name": "Trazado 1481",
    d: "M1732.381,1012.466c0-.164,0-.327,0-.491,0-1,0-2.021-.01-2.868a7.731,7.731,0,0,0-1-3.575,10.187,10.187,0,0,0-1.455-2.04l-1.6-1.3-5.39-4.337-.031-.067a1.706,1.706,0,0,0,.314-.43,1.738,1.738,0,0,0,.183-.777v-3.107a1.746,1.746,0,0,0-1.741-1.741h-.557a1.713,1.713,0,0,0-.887.25l-3.7-7.992a19.694,19.694,0,0,0-.853-2.9,7.485,7.485,0,0,0-7.131-4.478h-27.87v.046h-36.737v39.559h4.57c.4,2.045,1.641,3.545,3.123,3.545h2.058c1.482,0,2.719-1.5,3.123-3.545h9.53c.4,2.045,1.641,3.545,3.123,3.545h2.059c1.482,0,2.719-1.5,3.123-3.545h21.4a7.433,7.433,0,0,1-.1-1.263c0-.032.009-.06.009-.091l.094,1.354h.981c.4,2.045,1.642,3.545,3.124,3.545h2.058c1.482,0,2.719-1.5,3.123-3.545h15.365c.4,2.045,1.641,3.545,3.123,3.545h2.059c1.49,0,2.734-1.516,3.13-3.579a3.732,3.732,0,0,0,3.4-3.719",
    transform: "translate(-1430.64 -823.71)",
    fill: "#abc6dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1482",
    "data-name": "Trazado 1482",
    d: "M1802.232,780.045v8.189a4.585,4.585,0,0,1-4.588,4.588h-1.468a4.6,4.6,0,0,1-4.588-4.588v-8.189a4.516,4.516,0,0,1,.666-2.356v-.012a4.6,4.6,0,0,1,3.922-2.22h1.468a4.6,4.6,0,0,1,4.588,4.588",
    transform: "translate(-1555.202 -654.048)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4001",
    "data-name": "Grupo 4001",
    transform: "translate(236.387 123.641)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4000",
    "data-name": "Grupo 4000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3999",
    "data-name": "Grupo 3999",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1483",
    "data-name": "Trazado 1483",
    d: "M1801.75,802.309a4.6,4.6,0,0,1-4.107,2.541h-1.468a4.6,4.6,0,0,1-4.588-4.588v-8.189a4.518,4.518,0,0,1,.666-2.356c.086.506,2.035,11.742,9.5,12.593",
    transform: "translate(-1791.588 -789.716)",
    fill: "#c4c4c4"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1484",
    "data-name": "Trazado 1484",
    d: "M1389.7,1064.3h22.68v-22.89h-23.66Z",
    transform: "translate(-1215.41 -878.366)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1485",
    "data-name": "Trazado 1485",
    d: "M1251.5,576.84l-111.423,2.747V520.831h73.169a18.589,18.589,0,0,1,16.544,10.112l4.788,9.346Z",
    transform: "translate(-1005.694 -439.288)",
    fill: "#7db0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1486",
    "data-name": "Trazado 1486",
    d: "M1446.14,1093.436c0,6.214,3.205,13.067,3.205,13.067h5.426c4.767,0,8.631-5.85,8.631-13.067s-9.29-13.067-14.057-13.067-3.205,5.85-3.205,13.067",
    transform: "translate(-1263.632 -911.222)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1487",
    "data-name": "Trazado 1487",
    d: "M1412.8,1093.436c0,7.217,3.865,13.067,8.631,13.067s8.631-5.85,8.631-13.067-3.864-13.067-8.631-13.067-8.631,5.85-8.631,13.067",
    transform: "translate(-1235.72 -911.222)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1488",
    "data-name": "Trazado 1488",
    d: "M1427.1,1110.806c0,5.436,2.911,9.843,6.5,9.843s6.5-4.406,6.5-9.843-2.911-9.843-6.5-9.843-6.5,4.406-6.5,9.843",
    transform: "translate(-1247.78 -928.592)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1489",
    "data-name": "Trazado 1489",
    d: "M1844.62,1093.436c0,6.214,3.205,13.067,3.205,13.067h5.426c4.767,0,8.631-5.85,8.631-13.067s-9.29-13.067-14.057-13.067-3.205,5.85-3.205,13.067",
    transform: "translate(-1599.724 -911.222)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1490",
    "data-name": "Trazado 1490",
    d: "M1811.281,1093.436c0,7.217,3.864,13.067,8.631,13.067s8.631-5.85,8.631-13.067-3.864-13.067-8.631-13.067-8.631,5.85-8.631,13.067",
    transform: "translate(-1571.811 -911.222)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1491",
    "data-name": "Trazado 1491",
    d: "M1825.58,1110.806c0,5.436,2.911,9.843,6.5,9.843s6.5-4.406,6.5-9.843-2.911-9.843-6.5-9.843-6.5,4.406-6.5,9.843",
    transform: "translate(-1583.872 -928.592)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1492",
    "data-name": "Trazado 1492",
    d: "M929.551,1093.436c0,6.214,3.205,13.067,3.205,13.067h5.426c4.767,0,8.631-5.85,8.631-13.067s-9.29-13.067-14.057-13.067-3.205,5.85-3.205,13.067",
    transform: "translate(-827.922 -911.222)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1493",
    "data-name": "Trazado 1493",
    d: "M896.213,1093.436c0,7.217,3.864,13.067,8.631,13.067s8.631-5.85,8.631-13.067-3.864-13.067-8.631-13.067-8.631,5.85-8.631,13.067",
    transform: "translate(-800.01 -911.222)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1494",
    "data-name": "Trazado 1494",
    d: "M910.512,1110.806c0,5.436,2.911,9.843,6.5,9.843s6.5-4.406,6.5-9.843-2.911-9.843-6.5-9.843-6.5,4.406-6.5,9.843",
    transform: "translate(-812.071 -928.592)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1495",
    "data-name": "Trazado 1495",
    d: "M1284.865,904.71A9.869,9.869,0,0,1,1275,914.6h-63.913a19.546,19.546,0,0,0,.284-3.33c0-8.449-5.069-15.306-11.309-15.306s-11.322,6.857-11.322,15.306a19.543,19.543,0,0,0,.271,3.33h-37.346s-1.5-16.675-1.32-25.037c.148-7.277.148-21.534-.284-25.012,0-.518,36.014-.58,45.1-.617,1.233-.013,1.973-.013,2.047-.013l.123.086.136.1c1.677,1.172,11.075,7.758,16.909,11.618,5.143,3.392,43.106,4.773,57.993,5.193,3.7.1,5.982.135,5.982.135a26.881,26.881,0,0,1,3.836,5.378,20.384,20.384,0,0,1,2.639,9.423c.012,2.232.025,4.921.025,7.56.012.432.012.864.012,1.3",
    transform: "translate(-1014.113 -728.664)",
    fill: "#7db0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1496",
    "data-name": "Trazado 1496",
    d: "M1442.7,695.691h-50.075a2.959,2.959,0,0,1-2.688-1.726l-12.4-27.578a1.367,1.367,0,0,1,1.246-1.924h52.825a2.941,2.941,0,0,1,2.689,1.764l8.88,20.288,2.22,5.069a2.94,2.94,0,0,1-2.7,4.107",
    transform: "translate(-1205.876 -560.432)",
    fill: "#a2c2dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1497",
    "data-name": "Trazado 1497",
    d: "M1219.174,614.058c-.013.864-.049,1.678-.1,2.405-.358,4.8-5.18,8.781-5.18,8.781h-11.248a19.943,19.943,0,0,0-1.32-11.186c-1.986-4.465-5.587-7.449-9.706-7.449s-7.733,2.985-9.719,7.449a20.191,20.191,0,0,0-1.332,11.186h-40.516V520.853h32.524v20.72s9.756,22.916,14.147,33.005c1.085,2.516,1.85,4.23,2.047,4.6.974,1.862,23.644,13.332,27.393,16.712,2.084,1.875,3.121,11.618,3.01,18.167",
    transform: "translate(-1005.675 -439.306)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1498",
    "data-name": "Trazado 1498",
    d: "M1283.4,672.481l10.666,26.272h-18.3s-3.754-.629-4.235-8.3c-.514-8.191-.513-22.326-.513-22.326l8.033-.039c3.062.462,3.542,2.144,4.351,4.394",
    transform: "translate(-1116.131 -563.489)",
    fill: "#a2c2dd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1499",
    "data-name": "Trazado 1499",
    d: "M1532.364,881.055h-59.349l-21.67-17.045-.124-.086h59.867l17.045,13.715Z",
    transform: "translate(-1268.124 -728.664)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1500",
    "data-name": "Trazado 1500",
    d: "M1936.387,960.318a2,2,0,0,1-1.27,1.024l-8.325,1.542c-.7.136-1.246-1.085-1.061-2.343l.814-5.6.025-.135.16-1.147a2.42,2.42,0,0,1,1.11-1.949l.481-.185,4.231,3.416a26.871,26.871,0,0,1,3.836,5.377",
    transform: "translate(-1668.312 -802.549)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1501",
    "data-name": "Trazado 1501",
    d: "M1583.725,977.648l-5.365-.531a4.2,4.2,0,0,1-3.725-3.441l-1.234-6.783a.937.937,0,0,1-.025-.32,64.975,64.975,0,0,1,8.263,5.254c.888.8,1.591,3.022,2.085,5.822",
    transform: "translate(-1371.15 -815.242)",
    fill: "#a8302d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1502",
    "data-name": "Trazado 1502",
    d: "M1593.913,965.982l-10.175-1.011h-.012l-5.365-.531a4.2,4.2,0,0,1-3.725-3.441l-1.233-6.784a.943.943,0,0,1-.025-.32v-.013a2.257,2.257,0,0,1,2.714-2.294l15.849,3.219a2.73,2.73,0,0,1,2.084,1.949l1.863,6.882a1.857,1.857,0,0,1-1.974,2.343",
    transform: "translate(-1371.151 -802.565)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1503",
    "data-name": "Trazado 1503",
    d: "M1358.158,540.294h-61.829a35.763,35.763,0,0,0-1.79-8.474c-1.381-3.99-3.768-8.441-7.946-10.981h50.524c8.236,0,15.534,4.4,18.433,10.981a8.606,8.606,0,0,1,.358.818,51.671,51.671,0,0,1,2.251,7.656",
    transform: "translate(-1129.27 -439.294)",
    fill: "#7db0ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1504",
    "data-name": "Trazado 1504",
    d: "M1583.737,977.579l-5.377-.531a4.2,4.2,0,0,1-3.725-3.441l-1.234-6.783a1.01,1.01,0,0,1-.025-.333,66.118,66.118,0,0,1,8.263,5.266c.888.8,1.591,3.022,2.1,5.822",
    transform: "translate(-1371.15 -815.173)",
    fill: "#a2c2dd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4004",
    "data-name": "Grupo 4004",
    transform: "translate(195.653 174.751)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4003",
    "data-name": "Grupo 4003"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4002",
    "data-name": "Grupo 4002",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1505",
    "data-name": "Trazado 1505",
    d: "M1606.514,1117.461a10.114,10.114,0,0,1-10.348,9.891h-63.431a19.949,19.949,0,0,0-1.32-11.187H1606.5c.012.432.012.863.012,1.3",
    transform: "translate(-1531.416 -1116.166)",
    fill: "#7e7e7e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4007",
    "data-name": "Grupo 4007",
    transform: "translate(134.379 174.751)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4006",
    "data-name": "Grupo 4006"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4005",
    "data-name": "Grupo 4005",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1506",
    "data-name": "Trazado 1506",
    d: "M1180.3,1124.022a19.558,19.558,0,0,0,.271,3.33h-40.516v-11.187H1181.9a19.554,19.554,0,0,0-1.6,7.857",
    transform: "translate(-1140.054 -1116.165)",
    fill: "#9a9a9a"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4010",
    "data-name": "Grupo 4010",
    transform: "translate(227.685 152.873)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4009",
    "data-name": "Grupo 4009"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4008",
    "data-name": "Grupo 4008",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1507",
    "data-name": "Trazado 1507",
    d: "M1737.292,976.425h24.27c.775,0,1.368,1.045,1.25,2.2l-.861,8.435c-.127,1.241-.833,2.156-1.663,2.156h-20c-1.282,0-2.413-1.268-2.786-3.124l-1.44-7.171c-.25-1.244.365-2.5,1.225-2.5",
    transform: "translate(-1736.01 -976.425)",
    fill: "#547ed2"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1508",
    "data-name": "Trazado 1508",
    d: "M1507.421,686.515a89.482,89.482,0,0,1-53.836-22.052h42.267a2.94,2.94,0,0,1,2.689,1.764Z",
    transform: "translate(-1270.118 -560.432)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2585",
    "data-name": "Rect\\xE1ngulo 2585",
    width: 108.277,
    height: 104.402,
    transform: "translate(37.552 81.543)",
    fill: "#547ed2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1509",
    "data-name": "Trazado 1509",
    d: "M1360.317,777.79s.926,10.618-4.316,13.526h9.792Z",
    transform: "translate(-1187.812 -656.016)",
    fill: "#547ed2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1510",
    "data-name": "Trazado 1510",
    d: "M1379.821,807.672s-2.211-1.574-2.4-2.878v7.426h2.893Z",
    transform: "translate(-1205.878 -678.792)",
    fill: "#547ed2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1511",
    "data-name": "Trazado 1511",
    d: "M1320.068,780.045v8.189a4.585,4.585,0,0,1-4.588,4.588h-1.468a4.6,4.6,0,0,1-4.588-4.588v-8.189a4.516,4.516,0,0,1,.666-2.356v-.012a4.6,4.6,0,0,1,3.922-2.22h1.468a4.6,4.6,0,0,1,4.588,4.588",
    transform: "translate(-1148.528 -654.048)",
    fill: "#c4d9ed"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4013",
    "data-name": "Grupo 4013",
    transform: "translate(160.896 123.641)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4012",
    "data-name": "Grupo 4012"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4011",
    "data-name": "Grupo 4011",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1512",
    "data-name": "Trazado 1512",
    d: "M1319.587,802.309a4.6,4.6,0,0,1-4.107,2.541h-1.468a4.6,4.6,0,0,1-4.588-4.588v-8.189a4.517,4.517,0,0,1,.666-2.356c.086.506,2.035,11.742,9.5,12.593",
    transform: "translate(-1309.424 -789.716)",
    fill: "#699dee"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1513",
    "data-name": "Trazado 1513",
    d: "M602.08,1082.485H575.445c-.563-2.4-2.257-19.523,12.669-19.524,13.564,0,14.562,15.619,13.965,19.524",
    transform: "translate(-529.163 -896.539)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1514",
    "data-name": "Trazado 1514",
    d: "M629.3,1093.436c0,6.214,3.205,13.067,3.205,13.067h5.426c4.767,0,8.631-5.85,8.631-13.067s-9.29-13.067-14.057-13.067-3.205,5.85-3.205,13.067",
    transform: "translate(-574.682 -911.222)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1515",
    "data-name": "Trazado 1515",
    d: "M595.965,1093.436c0,7.217,3.864,13.067,8.631,13.067s8.631-5.85,8.631-13.067-3.864-13.067-8.631-13.067-8.631,5.85-8.631,13.067",
    transform: "translate(-546.771 -911.222)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1516",
    "data-name": "Trazado 1516",
    d: "M610.263,1110.806c0,5.436,2.911,9.843,6.5,9.843s6.5-4.406,6.5-9.843-2.911-9.843-6.5-9.843-6.5,4.406-6.5,9.843",
    transform: "translate(-558.83 -928.592)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4016",
    "data-name": "Grupo 4016",
    transform: "translate(165.267 92.526)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4015",
    "data-name": "Grupo 4015"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4014",
    "data-name": "Grupo 4014",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1517",
    "data-name": "Trazado 1517",
    d: "M1400.964,599.451h-61.829a35.765,35.765,0,0,0-1.79-8.474h61.01a8.429,8.429,0,0,1,.358.818,51.682,51.682,0,0,1,2.251,7.656",
    transform: "translate(-1337.344 -590.976)",
    fill: "#699dee"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1518",
    "data-name": "Trazado 1518",
    d: "M1298.388,108.372a20.225,20.225,0,0,0-20.225,20.225c0,11.17,20.225,36,20.225,36s20.225-24.833,20.225-36a20.225,20.225,0,0,0-20.225-20.225m0,29.473a9.454,9.454,0,1,1,9.454-9.454,9.454,9.454,0,0,1-9.454,9.454",
    transform: "translate(-1122.161 -91.405)",
    fill: "#1473f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1519",
    "data-name": "Trazado 1519",
    d: "M685.414,145.087a.388.388,0,0,1-.3-.141l-.484-.586a.388.388,0,1,1,.6-.495l.484.586a.388.388,0,0,1-.3.636m-1.143-1.386a.388.388,0,0,1-.3-.142l-.657-.8a.388.388,0,1,1,.6-.491l.656.8a.389.389,0,0,1-.3.635m-1.31-1.606a.388.388,0,0,1-.3-.144q-.323-.4-.651-.808a.388.388,0,1,1,.606-.486q.327.408.649.806a.388.388,0,0,1-.3.633m-1.3-1.617a.388.388,0,0,1-.3-.147q-.32-.4-.643-.815a.388.388,0,0,1,.611-.479q.322.41.64.812a.389.389,0,0,1-.3.63m-1.278-1.632a.388.388,0,0,1-.307-.151q-.315-.408-.633-.824a.388.388,0,1,1,.617-.471q.316.414.63.82a.388.388,0,0,1-.307.626m-1.257-1.647a.388.388,0,0,1-.311-.155q-.31-.413-.621-.833a.388.388,0,1,1,.624-.462q.309.418.618.828a.388.388,0,0,1-.31.622m-1.233-1.665a.388.388,0,0,1-.314-.16q-.3-.418-.608-.843a.388.388,0,0,1,.632-.452q.3.422.6.838a.388.388,0,0,1-.314.617m-1.205-1.686a.388.388,0,0,1-.318-.165q-.3-.423-.593-.854a.388.388,0,0,1,.64-.44q.294.427.589.848a.388.388,0,0,1-.318.611m-1.174-1.707a.388.388,0,0,1-.322-.171q-.289-.43-.577-.865a.388.388,0,0,1,.648-.427q.285.432.573.859a.388.388,0,0,1-.322.605m-1.141-1.73a.388.388,0,0,1-.327-.178q-.281-.436-.559-.878a.388.388,0,0,1,.657-.413q.275.438.554.87a.388.388,0,0,1-.326.6m-1.1-1.754a.388.388,0,0,1-.331-.185q-.272-.443-.539-.89a.388.388,0,1,1,.667-.4q.265.444.534.882a.389.389,0,0,1-.331.591m-1.062-1.779a.388.388,0,0,1-.336-.193q-.261-.449-.517-.9a.388.388,0,1,1,.677-.381q.253.45.512.895a.388.388,0,0,1-.336.583m-1.017-1.8a.388.388,0,0,1-.341-.2q-.25-.458-.494-.92a.388.388,0,1,1,.687-.363q.242.457.489.911a.389.389,0,0,1-.341.574m-.97-1.837a.388.388,0,0,1-.346-.212q-.237-.465-.468-.933a.388.388,0,0,1,.7-.343q.228.464.462.923a.388.388,0,0,1-.346.565m-.915-1.863a.388.388,0,0,1-.351-.223q-.222-.472-.438-.947a.388.388,0,1,1,.708-.32q.212.47.433.936a.388.388,0,0,1-.351.554m-.855-1.889a.389.389,0,0,1-.357-.234q-.207-.479-.406-.961a.388.388,0,0,1,.718-.3q.2.476.4.949a.389.389,0,0,1-.356.543m-.79-1.917a.388.388,0,0,1-.362-.247q-.19-.486-.371-.975a.388.388,0,1,1,.728-.27q.178.482.366.961a.389.389,0,0,1-.362.53m-.719-1.943a.388.388,0,0,1-.367-.261q-.171-.492-.333-.989a.388.388,0,1,1,.739-.241q.159.489.328.974a.388.388,0,0,1-.367.516m-.642-1.969a.389.389,0,0,1-.371-.276c-.1-.332-.2-.669-.292-1a.388.388,0,1,1,.748-.209c.092.328.189.659.288.986a.389.389,0,0,1-.372.5m-.559-1.994a.388.388,0,0,1-.376-.292c-.087-.338-.17-.68-.248-1.015a.388.388,0,1,1,.757-.176c.076.329.159.665.244,1a.388.388,0,0,1-.377.485m-.469-2.017a.389.389,0,0,1-.38-.31c-.071-.342-.138-.687-.2-1.026a.388.388,0,1,1,.764-.14c.061.333.127.672.2,1.007a.388.388,0,0,1-.3.459.392.392,0,0,1-.079.008m-.371-2.038a.388.388,0,0,1-.383-.328c-.054-.344-.1-.692-.149-1.036a.388.388,0,1,1,.77-.1c.044.336.093.678.146,1.016a.388.388,0,0,1-.324.444.379.379,0,0,1-.06,0m-.268-2.055a.389.389,0,0,1-.386-.348c-.036-.347-.068-.7-.094-1.043a.388.388,0,0,1,.775-.059c.026.338.057.682.092,1.022a.388.388,0,0,1-.346.426l-.041,0m-.158-2.068a.388.388,0,0,1-.388-.369c-.017-.349-.029-.7-.036-1.048a.388.388,0,1,1,.776-.016c.007.339.019.685.036,1.026a.388.388,0,0,1-.369.407h-.019m-.042-2.075h0a.388.388,0,0,1-.385-.392c0-.349.011-.7.024-1.047a.388.388,0,1,1,.776.029c-.012.338-.02.682-.023,1.024a.388.388,0,0,1-.388.385m.077-2.072h-.026a.388.388,0,0,1-.362-.413c.023-.348.052-.7.086-1.046a.388.388,0,0,1,.773.075c-.033.338-.061.682-.084,1.023a.388.388,0,0,1-.387.362m.2-2.063-.049,0a.388.388,0,0,1-.336-.434c.044-.345.094-.693.148-1.036a.388.388,0,0,1,.767.121c-.053.335-.1.676-.145,1.013a.388.388,0,0,1-.385.339m.323-2.045a.4.4,0,0,1-.073-.007.388.388,0,0,1-.309-.454c.065-.341.135-.686.21-1.026a.388.388,0,1,1,.758.167c-.073.332-.142.669-.206,1a.389.389,0,0,1-.381.316m.446-2.022a.389.389,0,0,1-.377-.483c.085-.336.176-.676.272-1.011a.388.388,0,0,1,.747.213c-.093.328-.183.66-.266.989a.388.388,0,0,1-.376.293m.567-1.991a.389.389,0,0,1-.37-.506c.1-.329.216-.663.331-.993a.388.388,0,0,1,.733.257c-.113.322-.222.649-.324.971a.389.389,0,0,1-.37.271m.684-1.954a.388.388,0,0,1-.363-.527c.124-.323.254-.65.388-.972a.388.388,0,1,1,.717.3c-.131.315-.259.635-.38.951a.389.389,0,0,1-.363.249m.8-1.911a.389.389,0,0,1-.354-.548c.142-.315.29-.634.442-.948a.388.388,0,1,1,.7.338c-.148.307-.294.619-.433.928a.389.389,0,0,1-.354.229m.9-1.864a.389.389,0,0,1-.345-.567c.158-.306.324-.617.492-.922a.388.388,0,1,1,.68.375c-.165.3-.327.6-.483.9a.388.388,0,0,1-.345.21m1-1.813a.388.388,0,0,1-.335-.584c.174-.3.355-.6.539-.9a.388.388,0,0,1,.66.409c-.181.292-.359.588-.529.878a.388.388,0,0,1-.335.192m1.09-1.761a.388.388,0,0,1-.325-.6c.189-.288.384-.58.581-.868a.388.388,0,1,1,.64.44c-.194.282-.386.569-.571.852a.388.388,0,0,1-.326.176m1.172-1.706a.388.388,0,0,1-.315-.616c.2-.28.411-.562.62-.84a.388.388,0,1,1,.619.468c-.206.273-.411.55-.61.826a.388.388,0,0,1-.315.161m1.249-1.652a.388.388,0,0,1-.3-.629c.213-.269.433-.542.656-.812a.388.388,0,1,1,.6.494c-.219.266-.436.535-.645.8a.388.388,0,0,1-.3.148m1.317-1.6a.388.388,0,0,1-.294-.641q.337-.392.687-.784a.388.388,0,1,1,.579.517q-.345.386-.677.773a.387.387,0,0,1-.295.135m1.379-1.544a.388.388,0,0,1-.285-.652q.352-.379.716-.758a.388.388,0,0,1,.56.539q-.359.373-.706.747a.387.387,0,0,1-.285.124m1.435-1.492a.388.388,0,0,1-.275-.662q.365-.366.742-.732a.388.388,0,1,1,.541.557q-.372.361-.732.723a.387.387,0,0,1-.275.114m1.486-1.442a.388.388,0,0,1-.266-.672q.376-.353.765-.707a.388.388,0,1,1,.523.575q-.384.349-.756.7a.387.387,0,0,1-.266.105m1.532-1.393a.388.388,0,0,1-.257-.68q.387-.342.786-.683a.388.388,0,1,1,.505.59q-.394.337-.777.675a.387.387,0,0,1-.257.1m1.573-1.347a.388.388,0,0,1-.249-.687q.4-.33.8-.66a.388.388,0,0,1,.488.6q-.4.326-.8.653a.387.387,0,0,1-.248.09m1.6-1.311a.388.388,0,0,1-.25-.686c.262-.219.522-.445.773-.67a.388.388,0,1,1,.518.579c-.258.23-.524.461-.792.686a.386.386,0,0,1-.249.091m1.543-1.38a.388.388,0,0,1-.268-.669c.246-.235.491-.477.727-.718a.388.388,0,0,1,.555.543c-.242.248-.493.5-.746.737a.387.387,0,0,1-.268.108m1.448-1.479a.388.388,0,0,1-.286-.65c.23-.251.457-.509.676-.766a.388.388,0,0,1,.591.5c-.225.264-.458.528-.694.786a.388.388,0,0,1-.287.126m1.343-1.576a.388.388,0,0,1-.3-.63c.211-.266.419-.539.62-.811a.388.388,0,1,1,.625.46c-.206.28-.42.561-.637.834a.387.387,0,0,1-.3.147m1.227-1.667a.388.388,0,0,1-.32-.607c.191-.28.379-.567.56-.854a.388.388,0,0,1,.657.414c-.185.295-.379.59-.575.878a.387.387,0,0,1-.321.17m1.1-1.752a.389.389,0,0,1-.336-.583c.169-.292.336-.593.5-.893a.388.388,0,1,1,.686.365c-.164.308-.335.617-.51.917a.388.388,0,0,1-.336.194m.971-1.826a.389.389,0,0,1-.349-.558c.148-.305.292-.617.429-.925a.388.388,0,0,1,.711.314c-.14.317-.288.637-.44.951a.388.388,0,0,1-.35.219m.836-1.892a.389.389,0,0,1-.361-.532c.125-.314.247-.635.361-.955a.388.388,0,1,1,.731.262c-.117.328-.242.658-.371.98a.388.388,0,0,1-.361.245m.7-1.948a.388.388,0,0,1-.37-.506c.1-.323.2-.652.293-.979a.388.388,0,0,1,.748.21c-.094.335-.2.673-.3,1a.388.388,0,0,1-.37.271m.56-1.993a.389.389,0,0,1-.378-.48c.08-.329.156-.664.225-1a.388.388,0,0,1,.76.158c-.071.342-.149.686-.231,1.023a.388.388,0,0,1-.377.3m.422-2.027a.389.389,0,0,1-.383-.455c.058-.334.111-.674.159-1.011a.388.388,0,1,1,.769.108c-.048.345-.1.693-.163,1.036a.388.388,0,0,1-.382.322m.289-2.051-.042,0a.388.388,0,0,1-.344-.428c.036-.336.068-.679.094-1.02a.388.388,0,0,1,.774.06c-.027.349-.059.7-.1,1.044a.389.389,0,0,1-.386.346m.159-2.066h-.018a.388.388,0,0,1-.37-.406c.016-.338.027-.682.033-1.024a.388.388,0,1,1,.776.013c-.006.35-.017.7-.033,1.047a.388.388,0,0,1-.388.37M693.9,44.7a.388.388,0,0,1-.388-.384c0-.34-.013-.684-.027-1.025a.388.388,0,0,1,.776-.031c.014.348.023.7.027,1.047a.388.388,0,0,1-.384.393h0m-.083-2.072a.388.388,0,0,1-.387-.362c-.023-.337-.05-.681-.083-1.022a.388.388,0,1,1,.773-.073c.033.348.061.7.084,1.043a.388.388,0,0,1-.361.413h-.026m-.195-2.061a.388.388,0,0,1-.385-.342c-.041-.338-.087-.68-.136-1.017a.388.388,0,1,1,.768-.113c.05.343.1.692.139,1.036a.388.388,0,0,1-.339.432.369.369,0,0,1-.047,0m-.3-2.049a.389.389,0,0,1-.382-.323c-.057-.333-.12-.672-.187-1.009a.388.388,0,0,1,.762-.15c.068.343.132.689.19,1.028a.388.388,0,0,1-.317.449.4.4,0,0,1-.066.006m-.4-2.032a.389.389,0,0,1-.379-.3c-.074-.333-.153-.669-.234-1A.388.388,0,1,1,693.06,35c.083.337.164.679.239,1.017a.388.388,0,0,1-.295.463.394.394,0,0,1-.085.009m-.5-2.011a.388.388,0,0,1-.375-.287c-.089-.328-.183-.66-.28-.988a.388.388,0,0,1,.745-.22c.1.333.194.672.285,1a.389.389,0,0,1-.375.49m-.588-1.99a.388.388,0,0,1-.37-.27c-.1-.324-.213-.653-.325-.978a.388.388,0,0,1,.734-.253c.114.331.225.665.33.995a.388.388,0,0,1-.37.507m-.675-1.965a.388.388,0,0,1-.365-.254c-.118-.321-.242-.646-.366-.963a.388.388,0,0,1,.723-.284c.127.323.252.652.372.979a.388.388,0,0,1-.364.523m-.758-1.934a.388.388,0,0,1-.359-.239c-.131-.315-.268-.633-.406-.947a.388.388,0,0,1,.711-.313c.14.318.279.642.412.961a.389.389,0,0,1-.358.538m-.837-1.9a.389.389,0,0,1-.352-.225c-.144-.31-.293-.622-.444-.929a.388.388,0,1,1,.7-.342c.153.312.3.629.45.943a.389.389,0,0,1-.352.552M599.551,25.1a.388.388,0,0,1-.333-.587c.008-.013.2-.333.586-.9a.388.388,0,1,1,.64.441c-.371.538-.556.849-.558.852a.388.388,0,0,1-.334.19m89.1-.274a.388.388,0,0,1-.346-.211q-.236-.457-.48-.91a.388.388,0,0,1,.683-.369q.248.46.487.924a.389.389,0,0,1-.345.566m-87.925-1.445a.388.388,0,0,1-.312-.619c.2-.274.415-.555.633-.836a.388.388,0,1,1,.613.477c-.214.275-.423.55-.621.819a.387.387,0,0,1-.313.158M687.666,23a.388.388,0,0,1-.338-.2q-.253-.448-.515-.89a.388.388,0,0,1,.668-.4q.266.449.523.9a.388.388,0,0,1-.338.58M602,21.741a.388.388,0,0,1-.3-.634c.217-.265.442-.534.671-.8a.388.388,0,1,1,.59.505c-.225.263-.447.528-.66.788a.387.387,0,0,1-.3.142m84.611-.523a.388.388,0,0,1-.331-.184q-.27-.437-.549-.868a.388.388,0,0,1,.652-.422q.283.438.558.881a.388.388,0,0,1-.33.593M603.35,20.166a.388.388,0,0,1-.289-.647c.231-.258.468-.518.7-.771a.388.388,0,1,1,.568.529c-.233.25-.466.506-.693.76a.387.387,0,0,1-.29.129m82.138-.686a.388.388,0,0,1-.322-.171q-.287-.426-.582-.845a.388.388,0,1,1,.635-.447q.3.426.591.858a.388.388,0,0,1-.322.605m-80.725-.831a.388.388,0,0,1-.279-.659q.354-.365.734-.742a.388.388,0,0,1,.547.552q-.374.371-.724.731a.387.387,0,0,1-.279.118m79.535-.86a.388.388,0,0,1-.313-.159q-.3-.414-.615-.821a.388.388,0,1,1,.617-.472q.316.413.624.833a.388.388,0,0,1-.313.618m-78.063-.6a.388.388,0,0,1-.268-.669q.37-.353.762-.713a.388.388,0,0,1,.525.572q-.386.355-.751.7a.387.387,0,0,1-.268.107m76.808-1.042a.387.387,0,0,1-.3-.146c-.212-.266-.429-.533-.647-.795a.388.388,0,1,1,.6-.5c.221.265.441.537.656.807a.388.388,0,0,1-.3.63m-75.282-.36a.388.388,0,0,1-.258-.679q.384-.34.788-.684a.388.388,0,1,1,.5.591q-.4.339-.777.674a.386.386,0,0,1-.257.1m73.963-1.228a.388.388,0,0,1-.294-.134c-.223-.258-.452-.517-.68-.77a.388.388,0,0,1,.577-.52c.232.258.465.521.691.782a.388.388,0,0,1-.294.643m-72.387-.116a.388.388,0,0,1-.247-.688q.4-.326.812-.654a.388.388,0,0,1,.481.61q-.409.323-.8.645a.387.387,0,0,1-.246.088m1.625-1.285a.388.388,0,0,1-.236-.7q.41-.312.835-.624a.388.388,0,1,1,.459.626q-.42.308-.824.616a.388.388,0,0,1-.235.079m69.373-.137a.387.387,0,0,1-.283-.122c-.234-.249-.474-.5-.712-.741a.388.388,0,1,1,.554-.544c.242.247.486.5.724.753a.388.388,0,0,1-.283.654m-67.7-1.087a.388.388,0,0,1-.224-.706q.422-.3.857-.594a.388.388,0,1,1,.436.643q-.43.292-.846.586a.387.387,0,0,1-.224.071m66.251-.391a.387.387,0,0,1-.271-.11c-.244-.238-.494-.476-.743-.709a.388.388,0,1,1,.53-.568c.253.236.508.479.756.721a.388.388,0,0,1-.271.666m-64.538-.773a.388.388,0,0,1-.213-.713q.432-.282.878-.562a.388.388,0,0,1,.413.658q-.44.276-.866.555a.385.385,0,0,1-.212.063m63.023-.639a.387.387,0,0,1-.258-.1c-.257-.229-.518-.456-.775-.674a.388.388,0,1,1,.5-.592c.261.222.527.453.788.686a.388.388,0,0,1-.258.678M616.1,9.67a.388.388,0,0,1-.2-.721q.442-.267.9-.531a.388.388,0,0,1,.389.672q-.449.26-.885.524a.384.384,0,0,1-.2.056m59.69-.879a.387.387,0,0,1-.244-.087c-.265-.215-.536-.429-.805-.637a.388.388,0,0,1,.474-.615c.274.212.55.43.82.648a.388.388,0,0,1-.245.69m-57.9-.159A.388.388,0,0,1,617.7,7.9q.452-.251.916-.5a.388.388,0,0,1,.365.685q-.458.244-.9.492a.387.387,0,0,1-.188.049m1.827-.974a.388.388,0,0,1-.177-.734q.461-.235.932-.466a.388.388,0,0,1,.341.7q-.466.228-.92.46a.386.386,0,0,1-.176.043m54.431-.131a.387.387,0,0,1-.229-.075c-.276-.2-.557-.4-.835-.6a.388.388,0,0,1,.442-.638c.283.2.57.4.852.607a.388.388,0,0,1-.229.7m-52.57-.778a.388.388,0,0,1-.165-.74q.469-.219.948-.433a.388.388,0,1,1,.316.709q-.473.211-.936.427a.386.386,0,0,1-.164.037m50.868-.4a.385.385,0,0,1-.212-.063c-.287-.187-.578-.372-.865-.55a.388.388,0,1,1,.408-.661c.294.181.591.37.883.561a.388.388,0,0,1-.213.713M623.471,5.9a.388.388,0,0,1-.152-.746q.476-.2.962-.4a.388.388,0,0,1,.292.72q-.48.195-.95.4a.388.388,0,0,1-.152.031m47.214-.645a.385.385,0,0,1-.194-.052c-.3-.171-.6-.339-.894-.5a.388.388,0,0,1,.369-.683c.3.165.612.337.914.511a.388.388,0,0,1-.195.724m-45.3-.134a.388.388,0,0,1-.14-.751q.483-.186.975-.367a.388.388,0,1,1,.267.729q-.486.178-.963.362a.385.385,0,0,1-.14.026m1.944-.712a.388.388,0,0,1-.127-.755q.489-.17.987-.333a.388.388,0,1,1,.243.738q-.492.162-.975.329a.39.39,0,0,1-.127.022m41.529-.139a.388.388,0,0,1-.174-.041c-.306-.154-.616-.3-.922-.445a.388.388,0,0,1,.327-.7c.313.145.63.3.943.456a.388.388,0,0,1-.175.735M629.3,3.766a.388.388,0,0,1-.115-.759q.494-.153,1-.3a.388.388,0,0,1,.218.745q-.5.145-.985.3a.388.388,0,0,1-.115.018M666.986,3.4a.388.388,0,0,1-.152-.031c-.313-.133-.632-.263-.947-.385a.388.388,0,1,1,.28-.724c.323.125.65.258.971.395a.388.388,0,0,1-.152.746m-35.7-.217a.388.388,0,0,1-.1-.763q.5-.137,1.006-.267a.388.388,0,0,1,.194.752q-.5.129-.995.264a.383.383,0,0,1-.1.014m2.005-.516A.388.388,0,0,1,633.2,1.9q.5-.121,1.015-.235a.388.388,0,0,1,.169.758q-.505.113-1,.232a.4.4,0,0,1-.091.011m31.761-.014a.388.388,0,0,1-.128-.022c-.322-.112-.649-.219-.971-.319a.388.388,0,0,1,.229-.742c.33.1.666.212,1,.327a.388.388,0,0,1-.128.755m-29.741-.437a.388.388,0,0,1-.078-.769q.507-.1,1.021-.2a.388.388,0,1,1,.145.763q-.509.1-1.01.2a.389.389,0,0,1-.079.008m27.763-.173a.4.4,0,0,1-.1-.013c-.33-.089-.663-.172-.99-.246a.388.388,0,0,1,.173-.757c.337.077.679.162,1.019.253a.388.388,0,0,1-.1.763m-25.729-.215a.388.388,0,0,1-.066-.771q.51-.089,1.027-.171a.388.388,0,1,1,.122.767q-.511.081-1.015.169a.393.393,0,0,1-.067.006m23.711-.246a.39.39,0,0,1-.072-.007c-.335-.063-.674-.119-1.005-.168a.388.388,0,1,1,.112-.768c.342.05.691.108,1.036.173a.388.388,0,0,1-.071.77m-21.667-.079a.388.388,0,0,1-.055-.773q.512-.074,1.032-.14a.388.388,0,1,1,.1.77q-.514.066-1.02.138a.4.4,0,0,1-.056,0m19.619-.221-.042,0q-.515-.056-1.026-.105a.388.388,0,0,1,.075-.773q.515.05,1.034.106a.388.388,0,0,1-.041.774m-17.565-.043A.388.388,0,0,1,641.4.469q.514-.058,1.035-.109a.388.388,0,1,1,.076.773q-.515.051-1.024.108l-.044,0m15.5-.157h-.034Q656.4,1.041,655.89,1a.388.388,0,0,1,.057-.775q.516.038,1.036.082a.388.388,0,0,1-.032.775M643.507,1.04a.388.388,0,0,1-.032-.775q.515-.043,1.038-.08a.388.388,0,1,1,.054.775q-.517.036-1.027.079h-.033M654.886.935h-.024Q654.344.9,653.833.878A.388.388,0,0,1,653.871.1q.516.025,1.038.057a.388.388,0,0,1-.023.776M645.573.9a.388.388,0,0,1-.021-.776q.517-.029,1.04-.051a.388.388,0,0,1,.032.776q-.518.022-1.029.05h-.022m7.245-.063H652.8q-.518-.019-1.03-.031a.388.388,0,0,1,.019-.776q.517.012,1.04.032a.388.388,0,0,1-.014.776M647.642.81a.388.388,0,0,1-.011-.777q.517-.015,1.04-.022h.006a.388.388,0,0,1,.006.777q-.518.008-1.03.022h-.011m3.106-.026h0q-.451,0-.9-.005h-.134a.388.388,0,0,1,0-.777h.135q.45,0,.9.005a.388.388,0,0,1,0,.777",
    transform: "translate(-549.468 -0.002)",
    fill: "#699ff0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1522",
    "data-name": "Trazado 1522",
    d: "M370.7,474.318l-.682.733c-1.62,1.756-6.019,6.531-10.862,12.021-1.142,1.3-2.319,2.643-3.5,3.99-1.756,2.03-3.479,4.059-5.082,6.02l-.017.017c-.495.58-.955,1.143-1.415,1.705-.955,1.177-1.842,2.3-2.66,3.359-2.455,3.205-4.177,5.8-4.5,7.11-1.961,8.2,1.859,31.29,2.848,36.933H291.256c1.62-11.731,3.871-28.305,4.161-30.829.443-3.973-13.42-21.024-13.658-33.472-.222-12.431,8-21.331,9.293-33.574.631-5.764-.086-13.266-1.006-19.66-.477-3.393-1.04-6.428-1.483-8.73a3.2,3.2,0,0,1,.853-2.882,2.809,2.809,0,0,1,.614-.495,3.141,3.141,0,0,1,3.018-.238c3.069,1.313,6.48,4.792,7.367,13.471,0,0,2.575,1.62,6.735,4.263,1.688,1.057,3.632,2.285,5.781,3.65,1.654,1.04,3.427,2.165,5.286,3.342.12.068.239.154.358.222.75.477,1.483.954,2.268,1.449h.017c.273.17.546.358.836.529q.742.486,1.534.972a2.035,2.035,0,0,0,.324.188c3.376,2.148,6.906,4.4,10.469,6.667h.017c.58.34,1.159.716,1.739,1.091.443.29.9.562,1.364.853.563.375,1.142.733,1.722,1.091h.017c4.041,2.558,8,5.081,11.7,7.418.58.375,1.16.733,1.722,1.091.461.29.9.58,1.347.853.6.375,1.142.733,1.705,1.109h.017c7.059,4.45,12.516,7.929,14.511,9.208.529.341.818.512.818.529",
    transform: "translate(-281.754 -350.91)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1523",
    "data-name": "Trazado 1523",
    d: "M326.9,427.06a2.782,2.782,0,0,1-2.354,2.935l-.372.055c-.486-3.378-1.041-6.423-1.484-8.726a12.217,12.217,0,0,1-.46-3.36c2.331-1.141,3.228,1.617,3.515,2.736a35.531,35.531,0,0,1,1.155,6.361",
    transform: "translate(-315.88 -352.297)",
    fill: "#ffc197"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4019",
    "data-name": "Grupo 4019",
    transform: "translate(28.225 129.256)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4018",
    "data-name": "Grupo 4018"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4017",
    "data-name": "Grupo 4017",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1524",
    "data-name": "Trazado 1524",
    d: "M507.709,836.474c-1.757,2.03-3.479,4.059-5.082,6.02l-.017.017c-.495.58-.955,1.143-1.415,1.705-.955,1.177-1.842,2.3-2.66,3.36-2.455,3.206-4.177,5.8-4.5,7.11-1.961,8.2,1.859,31.29,2.848,36.934H462.028c6.463-9.634,7.3-26.6,7.349-34.393a19.258,19.258,0,0,1,1.671-6.8,82.273,82.273,0,0,1,8.355-14.648c2.83-4.126,5.439-7.434,6.5-8.747v-.017c.341-.392.511-.614.511-.614l19.268-.818h.017l.256,1.364.2,1.159.887,4.809Z",
    transform: "translate(-462.028 -825.578)",
    fill: "#e2915a"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1525",
    "data-name": "Trazado 1525",
    d: "M446.14,294.283l-57.667,5.96a3.315,3.315,0,0,1-3.627-2.948L372.928,181.975a3.314,3.314,0,0,1,2.948-3.627l57.667-5.96a3.314,3.314,0,0,1,3.627,2.948l11.918,115.32a3.315,3.315,0,0,1-2.947,3.627",
    transform: "translate(-358.639 -145.384)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1526",
    "data-name": "Trazado 1526",
    d: "M485.913,290.174l-57.667,5.96a3.314,3.314,0,0,1-3.627-2.948L412.7,177.865a3.314,3.314,0,0,1,2.948-3.627l57.667-5.96a3.315,3.315,0,0,1,3.627,2.948l11.918,115.32a3.315,3.315,0,0,1-2.948,3.627",
    transform: "translate(-392.185 -141.917)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4022",
    "data-name": "Grupo 4022",
    transform: "translate(44.903 32.978)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4021",
    "data-name": "Grupo 4021"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4020",
    "data-name": "Grupo 4020",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1527",
    "data-name": "Trazado 1527",
    d: "M586.561,211.225a.655.655,0,0,0-.717-.583l-16.7,1.726a.653.653,0,1,0,.134,1.3l16.7-1.726a.655.655,0,0,0,.583-.717",
    transform: "translate(-568.558 -210.639)",
    fill: "#ccc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4025",
    "data-name": "Grupo 4025",
    transform: "translate(41.937 35.011)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4024",
    "data-name": "Grupo 4024"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4023",
    "data-name": "Grupo 4023",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1528",
    "data-name": "Trazado 1528",
    d: "M550.2,223.624a.653.653,0,1,0,.717.583.655.655,0,0,0-.717-.583",
    transform: "translate(-549.614 -223.621)",
    fill: "#cbcbcb"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4028",
    "data-name": "Grupo 4028",
    transform: "translate(60.781 140.206)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4027",
    "data-name": "Grupo 4027"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4026",
    "data-name": "Grupo 4026",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1529",
    "data-name": "Trazado 1529",
    d: "M678.378,899.3a4.213,4.213,0,1,0-3.758,4.623,4.213,4.213,0,0,0,3.758-4.623",
    transform: "translate(-669.974 -895.515)",
    fill: "#cbcbcb"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2592",
    "data-name": "Rect\\xE1ngulo 2592",
    width: 53.696,
    height: 99.119,
    transform: "translate(26.523 41.773) rotate(-5.9)",
    fill: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2593",
    "data-name": "Rect\\xE1ngulo 2593",
    width: 53.696,
    height: 11.506,
    transform: "matrix(0.995, -0.103, 0.103, 0.995, 35.531, 128.929)",
    fill: "#dfdfdf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1530",
    "data-name": "Trazado 1530",
    d: "M615.082,816.591l27.565-2.849a.582.582,0,1,0-.12-1.159l-27.565,2.849a.582.582,0,1,0,.12,1.159",
    transform: "translate(-562.352 -685.359)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1531",
    "data-name": "Trazado 1531",
    d: "M644.842,829.316a.584.584,0,0,0-.639-.519l-27.565,2.849a.582.582,0,1,0,.12,1.159l27.565-2.849a.584.584,0,0,0,.519-.639",
    transform: "translate(-563.766 -699.034)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1532",
    "data-name": "Trazado 1532",
    d: "M548.616,803.161a3.336,3.336,0,0,0-.29-1.092,3.882,3.882,0,0,0-4.024-2.421,3.932,3.932,0,0,0-3.462,3.188,4.273,4.273,0,0,0-.051,1.143c.221,2.148,4.638,6.547,4.638,6.547s3.411-5.2,3.189-7.366m-3.734,2.2a1.836,1.836,0,0,1-2.012-1.637,1.927,1.927,0,0,1,.239-1.125,1.859,1.859,0,0,1,1.4-.9,1.785,1.785,0,0,1,1.552.6,1.831,1.831,0,0,1-1.176,3.069",
    transform: "translate(-500.219 -674.434)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2594",
    "data-name": "Rect\\xE1ngulo 2594",
    width: 30.961,
    height: 25.529,
    transform: "translate(34.074 55.725) rotate(-5.901)",
    fill: "#c8c8c8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2595",
    "data-name": "Rect\\xE1ngulo 2595",
    width: 26.061,
    height: 25.529,
    transform: "matrix(0.995, -0.103, 0.103, 0.995, 49.473, 54.134)",
    fill: "#dedede"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4031",
    "data-name": "Grupo 4031",
    transform: "translate(49.473 54.134)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4030",
    "data-name": "Grupo 4030"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4029",
    "data-name": "Grupo 4029",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1533",
    "data-name": "Trazado 1533",
    d: "M625.624,362.036l.666,6.44-25.923,2.679-2.624-25.394Z",
    transform: "translate(-597.742 -345.761)",
    fill: "#c8c8c8"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1534",
    "data-name": "Trazado 1534",
    d: "M510.707,461.572l4.88-.5-.572-1.329.328-1.026-4.88.5Z",
    transform: "translate(-474.656 -386.895)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1535",
    "data-name": "Trazado 1535",
    d: "M503.956,396.246l4.88-.5-.572-1.329.328-1.026-4.88.5Z",
    transform: "translate(-468.962 -331.797)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4034",
    "data-name": "Grupo 4034",
    transform: "translate(71.174 57.826)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4033",
    "data-name": "Grupo 4033"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4032",
    "data-name": "Grupo 4032",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1536",
    "data-name": "Trazado 1536",
    d: "M741.478,371.7l-4.88.5.288-1.418-.531-.937,4.88-.5Z",
    transform: "translate(-736.355 -369.345)",
    fill: "#d6d6d6"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1537",
    "data-name": "Trazado 1537",
    d: "M518.67,561.559a3.594,3.594,0,0,0-.512-.273,3.488,3.488,0,0,0-1.586-.222,3.276,3.276,0,0,0-2.78,2.285,3.068,3.068,0,0,0-.136,1.313,3.285,3.285,0,0,0,3.6,2.916,3.017,3.017,0,0,0,1.876-.87,3.172,3.172,0,0,0,1.04-2.728,3.244,3.244,0,0,0-1.5-2.421m.136,4.962a2.857,2.857,0,0,1-1.586.682,2.892,2.892,0,0,1-3.172-2.575,2.757,2.757,0,0,1,.1-1.057,2.841,2.841,0,0,1,2.473-2.131,2.549,2.549,0,0,1,1.347.2,2.187,2.187,0,0,1,.563.29,2.889,2.889,0,0,1,.273,4.587",
    transform: "translate(-477.332 -473.21)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1538",
    "data-name": "Trazado 1538",
    d: "M522.49,546.813l2.074,3.227,2.779-7.987-3.022,5.638Z",
    transform: "translate(-484.799 -457.186)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1539",
    "data-name": "Trazado 1539",
    d: "M528.128,640.671a3.277,3.277,0,0,0-1.5-2.438,4.981,4.981,0,0,0-.512-.273,3.526,3.526,0,0,0-1.586-.221,3.275,3.275,0,1,0,3.6,2.933m-2.967,3.206a2.888,2.888,0,1,1-.58-5.747,2.731,2.731,0,0,1,1.347.188,2.173,2.173,0,0,1,.563.29,2.866,2.866,0,0,1,1.262,2.1,2.914,2.914,0,0,1-2.591,3.172",
    transform: "translate(-484.046 -537.879)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1540",
    "data-name": "Trazado 1540",
    d: "M530.414,623.5l2.074,3.227,2.779-7.987-3.022,5.638Z",
    transform: "translate(-491.483 -521.868)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1541",
    "data-name": "Trazado 1541",
    d: "M536.079,717.328a3.274,3.274,0,1,0-2.916,3.6,3.286,3.286,0,0,0,2.916-3.6m-2.967,3.206a2.889,2.889,0,1,1,2.575-3.172,2.889,2.889,0,0,1-2.575,3.172",
    transform: "translate(-490.752 -602.531)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1542",
    "data-name": "Trazado 1542",
    d: "M613.259,546.189l-30.836,3.187a.572.572,0,0,1-.626-.509l-.013-.126a.573.573,0,0,1,.509-.627l30.836-3.187a.573.573,0,0,1,.627.509l.013.126a.573.573,0,0,1-.509.627",
    transform: "translate(-534.807 -459.609)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1543",
    "data-name": "Trazado 1543",
    d: "M614.742,560.53l-30.836,3.187a.573.573,0,0,1-.627-.509l-.013-.126a.573.573,0,0,1,.509-.627l30.836-3.187a.573.573,0,0,1,.627.509l.013.126a.572.572,0,0,1-.509.626",
    transform: "translate(-536.058 -471.705)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1544",
    "data-name": "Trazado 1544",
    d: "M621.2,623.007l-30.836,3.187a.572.572,0,0,1-.627-.509l-.013-.126a.573.573,0,0,1,.509-.627l30.836-3.187a.573.573,0,0,1,.626.509l.013.126a.573.573,0,0,1-.509.627",
    transform: "translate(-541.504 -524.4)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1545",
    "data-name": "Trazado 1545",
    d: "M622.681,637.349l-30.836,3.187a.573.573,0,0,1-.627-.509l-.013-.125a.573.573,0,0,1,.509-.627l30.836-3.187a.573.573,0,0,1,.627.509l.013.125a.573.573,0,0,1-.509.627",
    transform: "translate(-542.754 -536.497)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1546",
    "data-name": "Trazado 1546",
    d: "M629.138,699.824,598.3,703.011a.572.572,0,0,1-.626-.509l-.013-.126a.572.572,0,0,1,.509-.626l30.836-3.187a.573.573,0,0,1,.627.509l.013.126a.572.572,0,0,1-.509.626",
    transform: "translate(-548.2 -589.19)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1547",
    "data-name": "Trazado 1547",
    d: "M630.619,714.165l-30.836,3.187a.572.572,0,0,1-.627-.509l-.013-.125a.573.573,0,0,1,.509-.627l30.836-3.187a.573.573,0,0,1,.627.509l.013.126a.573.573,0,0,1-.509.627",
    transform: "translate(-549.449 -601.286)",
    fill: "#d5d5d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1548",
    "data-name": "Trazado 1548",
    d: "M833.635,265.32s8.37-7.437,13.86-3.216-12.351,17.816-12.351,17.816Z",
    transform: "translate(-747.23 -219.974)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1549",
    "data-name": "Trazado 1549",
    d: "M787.712,409.961l-9.727,5.38a5.876,5.876,0,0,1-7.963-2.291l-1.589-2.872a5.876,5.876,0,0,1,2.291-7.963l9.726-5.38a5.876,5.876,0,0,1,7.963,2.291L790,402a5.876,5.876,0,0,1-2.291,7.963",
    transform: "translate(-691.623 -334.091)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1550",
    "data-name": "Trazado 1550",
    d: "M798.469,514.049l-9.726,5.38a5.876,5.876,0,0,1-7.963-2.291l-1.589-2.872a5.876,5.876,0,0,1,2.291-7.963l9.727-5.38a5.876,5.876,0,0,1,7.963,2.291l1.589,2.872a5.876,5.876,0,0,1-2.291,7.962",
    transform: "translate(-700.696 -421.883)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1551",
    "data-name": "Trazado 1551",
    d: "M808.935,615.324l-9.726,5.38a5.876,5.876,0,0,1-7.963-2.291l-1.589-2.872a5.876,5.876,0,0,1,2.291-7.963l9.727-5.38a5.876,5.876,0,0,1,7.963,2.291l1.589,2.872a5.876,5.876,0,0,1-2.291,7.963",
    transform: "translate(-709.524 -507.302)",
    fill: "#ffb27d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1552",
    "data-name": "Trazado 1552",
    d: "M768.385,441.263a34.852,34.852,0,0,1,5.455-3.464,2.787,2.787,0,0,1,3.607,1.064l2.133,3.564a2.634,2.634,0,0,1-.868,3.6,47.124,47.124,0,0,1-5.792,3.078,3.244,3.244,0,0,1-4.1-1.394l-1.295-2.294a3.213,3.213,0,0,1,.864-4.151",
    transform: "translate(-691.115 -369.02)",
    fill: "#ffc197"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1553",
    "data-name": "Trazado 1553",
    d: "M779.439,548.219a34.831,34.831,0,0,1,5.454-3.464,2.787,2.787,0,0,1,3.607,1.064l2.132,3.564a2.634,2.634,0,0,1-.868,3.6,47.091,47.091,0,0,1-5.791,3.078,3.244,3.244,0,0,1-4.1-1.394l-1.295-2.294a3.213,3.213,0,0,1,.864-4.151",
    transform: "translate(-700.438 -459.23)",
    fill: "#ffc197"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1554",
    "data-name": "Trazado 1554",
    d: "M791.768,648.463A34.863,34.863,0,0,1,797.222,645a2.787,2.787,0,0,1,3.607,1.064l2.133,3.564a2.634,2.634,0,0,1-.868,3.6A47.126,47.126,0,0,1,796.3,656.3a3.245,3.245,0,0,1-4.1-1.394l-1.295-2.294a3.213,3.213,0,0,1,.864-4.151",
    transform: "translate(-710.837 -543.78)",
    fill: "#ffc197"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1555",
    "data-name": "Trazado 1555",
    d: "M1134.664,963.735l22.485,3.538-14.805-10.407-.807,3.256-5.494.913Z",
    transform: "translate(-1001.129 -807.056)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1556",
    "data-name": "Trazado 1556",
    d: "M1079.1,963.4l-18.61-9.937-18.363-1.189Z",
    transform: "translate(-923.075 -803.181)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1557",
    "data-name": "Trazado 1557",
    d: "M1183.716,926.226l14.805,10.407-11.346-16.094Z",
    transform: "translate(-1042.501 -776.415)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1558",
    "data-name": "Trazado 1558",
    d: "M879.09,81.228l-17.462-9,15.615.3-1.1,2.679,3.36,3.436Z",
    transform: "translate(-770.84 -60.922)",
    fill: "#afafaf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1559",
    "data-name": "Trazado 1559",
    d: "M861.627,72.231,879.653,74.8l13.394,8.533Z",
    transform: "translate(-770.84 -60.922)",
    fill: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1560",
    "data-name": "Trazado 1560",
    d: "M877.242,43.308l-15.615-.3,16.1-5.425Z",
    transform: "translate(-770.84 -31.7)",
    fill: "#d4d4d4"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4044",
    "data-name": "Grupo 4044",
    transform: "translate(2415.017 615.667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4043",
    "data-name": "Grupo 4043",
    transform: "translate(-617 -107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4045",
    "data-name": "Grupo 4045",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1561",
    "data-name": "Trazado 1561",
    d: "M400.383,141.936s51.67,6.238,68.119-17.362c21.34-30.619-22.5-53.835-56.127-49.509-73.269,9.425-72.352-129.785-171.648-50.61C214.457,45.4,179.049,7.832,136.181,54.2,126.163,65.035,64.934,44.091,34.462,52.667-25.175,69.451,2.093,142.219,44.706,142.5s355.677-.569,355.677-.569",
    transform: "translate(-0.001 0.004)",
    fill: "#f3f3f3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2598",
    "data-name": "Rect\\xE1ngulo 2598",
    width: 58.028,
    height: 140.066,
    transform: "translate(341.973 2.303)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2599",
    "data-name": "Rect\\xE1ngulo 2599",
    width: 10.346,
    height: 140.066,
    transform: "translate(341.92 2.303)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2600",
    "data-name": "Rect\\xE1ngulo 2600",
    width: 58.028,
    height: 140.066,
    transform: "translate(354.797 2.303)",
    fill: "#d2e4ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2601",
    "data-name": "Rect\\xE1ngulo 2601",
    width: 10.766,
    height: 140.066,
    transform: "translate(400.139 2.303)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1562",
    "data-name": "Trazado 1562",
    d: "M2519.84,1142.321c-.1,1.188-1.773,1.188-3.674.953s-7.64-.6-7.767-.984c-.112-.339,1.173-.614,2.548-.937.173-.04.347-.083.521-.125a7,7,0,0,0,3.917-2.535c1.156-1.481,2.212-8.224,2.212-8.224l4.164.777s-2.424,5.78-2.672,7.676c-.111.851.493,1.418.635,2.162a4.655,4.655,0,0,1,.117,1.237",
    transform: "translate(-2222.031 -1001.413)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1563",
    "data-name": "Trazado 1563",
    d: "M2519.842,1224.687c-.1,1.187-1.773,1.188-3.674.953a5.487,5.487,0,0,0-2.315.149h-3.343c-1.455-.251-2.013-.84-2.108-1.134-.113-.338,1.172-.613,2.548-.937l.016.025a7.465,7.465,0,0,0,3.9.729c1.79-.167,3.62-.9,4.855-1.024a4.7,4.7,0,0,1,.116,1.238",
    transform: "translate(-2222.034 -1083.778)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1564",
    "data-name": "Trazado 1564",
    d: "M2576.056,749.828a6.813,6.813,0,0,0,2.116.908,4.255,4.255,0,0,0,2.253-.031s7.4-18.575,6.976-24.852c-.01-.151-.016-.311-.018-.481a26.363,26.363,0,0,1,.415-4.211c.1-.612.215-1.254.342-1.918.3-1.547.664-3.217,1.067-4.919.177-.75.363-1.505.551-2.261,1.859-7.427,4.133-14.746,4.133-14.746s-13.351-4.361-14.106-.285a81.3,81.3,0,0,0-.82,17.394,138.047,138.047,0,0,1-.542,20.687,114.141,114.141,0,0,1-2.367,14.715",
    transform: "translate(-2281.97 -615.916)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1565",
    "data-name": "Trazado 1565",
    d: "M2665.644,825.862a26.37,26.37,0,0,1,.415-4.211c.1-.613.214-1.254.342-1.918.3-1.547.664-3.217,1.067-4.919.177-.75.363-1.505.551-2.261-.264-2.266-.477-3.821-.477-3.821a19,19,0,0,0-1.9,17.13",
    transform: "translate(-2360.232 -716.406)",
    fill: "#285493"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1566",
    "data-name": "Trazado 1566",
    d: "M2667.371,1152.207c-.1,1.188-1.773,1.188-3.675.953s-7.64-.6-7.766-.984c-.113-.339,1.173-.614,2.548-.938.173-.04.346-.083.52-.125,1.551-.382,2.584-1.533,3.917-2.535,1.262-.949.379-5.552.379-5.552l3.915-1.4s-.59,4.63-.59,7.178c0,.858.493,1.418.635,2.163a4.665,4.665,0,0,1,.117,1.237",
    transform: "translate(-2352.72 -1011.299)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1567",
    "data-name": "Trazado 1567",
    d: "M2667.373,1224.687c-.1,1.187-1.773,1.188-3.674.953a5.489,5.489,0,0,0-2.315.149h-3.342c-1.455-.251-2.013-.84-2.109-1.134-.113-.338,1.173-.613,2.548-.937l.016.025a7.465,7.465,0,0,0,3.9.729c1.79-.167,3.62-.9,4.855-1.024a4.7,4.7,0,0,1,.117,1.238",
    transform: "translate(-2352.722 -1083.778)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1568",
    "data-name": "Trazado 1568",
    d: "M2661.833,660.253s4.343,21.647,5.077,33.429,1.65,21.536,1.65,21.536a5.743,5.743,0,0,0,2.035.28,7.48,7.48,0,0,0,2.059-.42s4.305-17.727,2.879-24.822-.238-13.64.447-19.526c.981-8.439-2.795-12.361-5.431-15.035-2.668-2.706-8.716,4.557-8.716,4.557",
    transform: "translate(-2357.955 -580.305)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1569",
    "data-name": "Trazado 1569",
    d: "M2624.554,288.132c-.432-3.524.669-9.164,7.7-8.263s9.251,7.814,7.833,10.888,2.042,3.815,3.128,7.121c.933,2.84,1.259,6.365,2.769,7.948,4.87,5.1-4.675,12.947-10.429,11.292-10.481-3.013-11.831-3.463-11.459-11.7.19-4.219,3.473-5.854,1.389-7.075-5.035-2.949.042-2.238-.935-10.213",
    transform: "translate(-2323.754 -247.833)",
    fill: "#aa443e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1570",
    "data-name": "Trazado 1570",
    d: "M2653.522,386.6l2.081,3.121,4.192-.206,1.937-5.006s-.6-.113-.876-6.355l-5.232,1.6a10.2,10.2,0,0,1-.092,3.4,5.643,5.643,0,0,1-2.009,3.451",
    transform: "translate(-2350.592 -334.98)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1571",
    "data-name": "Trazado 1571",
    d: "M2618.638,429.183c.269,0,5.2-1.649,12.237,1.218,0,0-3.341,19.117-1.906,22.765a38.567,38.567,0,0,1,1.981,6.886l-15.57.193s.218-12.523-.5-16.955,3.759-14.107,3.759-14.107",
    transform: "translate(-2316.292 -379.768)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1572",
    "data-name": "Trazado 1572",
    d: "M2458.24,454.39a6.493,6.493,0,0,1-.179-.967,14.894,14.894,0,0,1,.722-6.034.012.012,0,0,0,0-.006c.009-.029.018-.059.028-.088.016-.048.036-.123.059-.219a.04.04,0,0,0,0-.007c.023-.088.047-.193.075-.313l.027-.127c.4-1.795,1.28-6.3,1.512-6.917a6.016,6.016,0,0,0,.239-.984c.235-1.357.338-3.516-.453-4.419-1.1-1.256-4.884-2.157-4.884-2.157-.769,1.205-3.373,4.153-6.642,3.614-1.89-.312-2.181-3.989-2.181-3.989a8.226,8.226,0,0,0-2.55.588s-4.867,3.037-11.744,12.707c-.218.307-.738.272-2.007.026-1.616-.315-4.916-.274-9.894-1,0,0-.171.124-.218.668a8.058,8.058,0,0,1-.223,1.557,62.052,62.052,0,0,0,6.765,2.649c1.233.392,2.522.757,3.753,1.032a19.241,19.241,0,0,0,3.192.479,22.958,22.958,0,0,0,7.823-5.769c.224,3.561.721,8.16.416,11.518-.174,1.912-1.482,8.345-1.154,9.416.684,2.23,5.936,2.345,10.627,2.112l.307-.017c.727-.042,1.441-.105,2.108-.18a28.96,28.96,0,0,0,3.055-.487,14.81,14.81,0,0,0,3-.962,3.189,3.189,0,0,0,1.566-1.327c-.451-2.427-2.624-7.712-3.147-10.393",
    transform: "translate(-2143.667 -382.484)",
    fill: "#80bdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1573",
    "data-name": "Trazado 1573",
    d: "M2641.93,493.568c.888,3.014,1.4,5.495,3.637,7.172.727-.042,1.441-.105,2.108-.18a28.948,28.948,0,0,0,3.055-.487,14.8,14.8,0,0,0,3-.962,3.188,3.188,0,0,0,1.566-1.327c-.451-2.427-2.624-7.712-3.147-10.393a6.5,6.5,0,0,1-.1-.7,17.489,17.489,0,0,1,.647-6.3.013.013,0,0,0,0-.006l.087-.307a.04.04,0,0,1,0-.007c.019-.066.044-.173.074-.313.009-.039.018-.081.027-.127.358-1.7,1.3-7.036,1.534-7.733a7.1,7.1,0,0,0,.234-1.063l-1.875-1.8s-10.756,4.593-13.125,10.929,1,9.286,2.279,13.61",
    transform: "translate(-2337.576 -415.485)",
    fill: "#5f9aa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1574",
    "data-name": "Trazado 1574",
    d: "M2479.184,535.734a30.119,30.119,0,0,0,6.945,1.511,22.988,22.988,0,0,0,7.9-5.852c.163-.732.321-1.96-.566-1.605-1.244.5-5.842,6.4-7.583,6.526a54.044,54.044,0,0,1-6.7-.579",
    transform: "translate(-2196.157 -469.251)",
    fill: "#5f9aa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1575",
    "data-name": "Trazado 1575",
    d: "M2553.6,460.893a55.179,55.179,0,0,0,9.9,3.765,20.625,20.625,0,0,0,3.684.593,17.607,17.607,0,0,0,8.716-6.805c6.784-9.908,1.661-11.309,1.661-11.309s-4.868,3.037-11.744,12.707c-.241.339-.845.262-2.409-.054-1.671-.337-5-.3-9.586-.971a2.559,2.559,0,0,0-.125.715c-.1,1.2-.1,1.359-.1,1.359",
    transform: "translate(-2262.074 -396.091)",
    fill: "#80bdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1576",
    "data-name": "Trazado 1576",
    d: "M2388.6,531.964c-1.6-.312-5-.336-9.9-1.046a8.567,8.567,0,0,1-1.215-.482c-1.049-.525-3.847-.874-4.442-.315s.629,2.833,3.183,2.9a16.338,16.338,0,0,1,2.06.169,62.063,62.063,0,0,0,6.744,2.639c1.233.392,2.522.757,3.753,1.032a9.056,9.056,0,0,0-.183-4.9",
    transform: "translate(-2101.999 -469.35)",
    fill: "#a86337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1577",
    "data-name": "Trazado 1577",
    d: "M2671.116,383.145c2.163-.175,5.325-5,5.325-5l-5.232,1.6a10.208,10.208,0,0,1-.092,3.4",
    transform: "translate(-2366.178 -334.98)",
    fill: "#cc7c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1578",
    "data-name": "Trazado 1578",
    d: "M2651.489,314.98s6.265,1.258,6.989-2.656,2.019-6.387-1.95-7.356-5.025.381-5.584,1.628-1.065,7.956.546,8.384",
    transform: "translate(-2347.828 -269.859)",
    fill: "#d9935c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1579",
    "data-name": "Trazado 1579",
    d: "M2686.736,297.65s-.11,1.327,1.951,3.58,1.57,6.269,1.57,6.269,3.472-6.528,1.62-8.612-5.141-1.237-5.141-1.237",
    transform: "translate(-2380.014 -263.519)",
    fill: "#aa443e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1580",
    "data-name": "Trazado 1580",
    d: "M2653.071,282.507s-3.115-1.042-6.206,2c-1.331,1.312-1.13,3.892-.417,5.389,0,0,1.1-3.207,3.089-3.907s3.534-3.485,3.534-3.485",
    transform: "translate(-2343.83 -250.103)",
    fill: "#aa443e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1581",
    "data-name": "Trazado 1581",
    d: "M2659.545,374.548s-.167.465-1.347.254c0,0-.991-.177-.9-.7a3.231,3.231,0,0,1,2.246.445",
    transform: "translate(-2353.933 -331.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1582",
    "data-name": "Trazado 1582",
    d: "M2389.013,470.481l-13.341.3,3.062,18.536,13.506.437Z",
    transform: "translate(-2104.462 -416.77)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1583",
    "data-name": "Trazado 1583",
    d: "M2512.406,543.644a5.411,5.411,0,0,1-.091-4.868c-1.67-.338-5.019-.484-9.609-1.158v.008a10.217,10.217,0,0,1-1.881-.683c-1.12-.56-4.108-.934-4.743-.336s.673,3.024,3.4,3.1a13.755,13.755,0,0,1,2.938.328,63.639,63.639,0,0,0,9.989,3.61",
    transform: "translate(-2210.986 -475.077)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2602",
    "data-name": "Rect\\xE1ngulo 2602",
    width: 31.981,
    height: 31.981,
    transform: "translate(178.835 76.091)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2603",
    "data-name": "Rect\\xE1ngulo 2603",
    width: 31.981,
    height: 31.981,
    transform: "translate(188.696 76.091)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2604",
    "data-name": "Rect\\xE1ngulo 2604",
    width: 34.325,
    height: 34.325,
    transform: "translate(206.084 108.072)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2605",
    "data-name": "Rect\\xE1ngulo 2605",
    width: 34.325,
    height: 34.325,
    transform: "translate(216.667 108.072)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1584",
    "data-name": "Trazado 1584",
    d: "M1815.783,946.659l-10.583,6.416v-6.416Z",
    transform: "translate(-1599.116 -838.587)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1585",
    "data-name": "Trazado 1585",
    d: "M4220.389,1142.579c-.1,1.2-11.46.356-11.588-.031-.114-.343,1.188-.621,2.582-.95.175-.041.351-.083.527-.127a7.085,7.085,0,0,0,3.967-2.568c1.17-1.5,2.24-8.331,2.24-8.331l4.218.787s-2.456,5.855-2.708,7.774c-.113.862.5,1.437.644,2.191a4.773,4.773,0,0,1,.118,1.253",
    transform: "translate(-3728.312 -1001.506)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1586",
    "data-name": "Trazado 1586",
    d: "M4220.389,1226.011a1.048,1.048,0,0,1-.827.939h-3.137a4.493,4.493,0,0,0-1.167,0h-5.069c-.924-.294-1.31-.73-1.389-.969-.114-.343,1.188-.621,2.582-.95l.016.026a7.566,7.566,0,0,0,3.956.739c1.812-.169,3.666-.911,4.917-1.036a4.787,4.787,0,0,1,.119,1.252",
    transform: "translate(-3728.312 -1084.939)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1587",
    "data-name": "Trazado 1587",
    d: "M4277.33,745.025a6.9,6.9,0,0,0,2.144.92,4.308,4.308,0,0,0,2.282-.031s7.494-18.815,7.065-25.173q-.015-.229-.018-.487a26.653,26.653,0,0,1,.42-4.265c.1-.62.217-1.27.346-1.942.3-1.568.672-3.259,1.081-4.983.18-.759.367-1.525.559-2.29,1.883-7.523,4.186-14.936,4.186-14.936s-13.522-4.417-14.287-.289a82.33,82.33,0,0,0-.832,17.618,139.947,139.947,0,0,1-.548,20.954,115.553,115.553,0,0,1-2.4,14.905",
    transform: "translate(-3789.024 -611.038)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1588",
    "data-name": "Trazado 1588",
    d: "M4368.074,822.04a26.586,26.586,0,0,1,.42-4.265c.1-.62.217-1.27.347-1.942.3-1.568.672-3.259,1.08-4.983.18-.759.368-1.525.559-2.29-.267-2.3-.482-3.87-.482-3.87a19.243,19.243,0,0,0-1.923,17.351",
    transform: "translate(-3868.296 -712.824)",
    fill: "#285493"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1589",
    "data-name": "Trazado 1589",
    d: "M4369.822,1152.594c-.1,1.2-11.46.356-11.588-.031-.115-.343,1.188-.621,2.581-.949.176-.041.352-.084.527-.127,1.571-.387,2.618-1.553,3.967-2.567,1.278-.961.383-5.624.383-5.624l3.966-1.416s-.6,4.69-.6,7.271c0,.869.5,1.437.643,2.19a4.734,4.734,0,0,1,.119,1.253",
    transform: "translate(-3860.687 -1011.52)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1590",
    "data-name": "Trazado 1590",
    d: "M4369.819,1226.011a1.047,1.047,0,0,1-.827.939h-3.137a4.507,4.507,0,0,0-1.168,0h-5.067c-.924-.294-1.311-.73-1.389-.969-.114-.343,1.188-.621,2.581-.95l.018.026a7.565,7.565,0,0,0,3.955.739c1.813-.169,3.667-.911,4.917-1.036a4.7,4.7,0,0,1,.119,1.252",
    transform: "translate(-3860.684 -1084.939)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1591",
    "data-name": "Trazado 1591",
    d: "M4364.212,654.295s4.4,21.927,5.143,33.86,1.671,21.814,1.671,21.814a5.813,5.813,0,0,0,2.062.283,7.6,7.6,0,0,0,2.086-.425s4.36-17.955,2.916-25.142-.242-13.816.452-19.778c.995-8.548-2.831-12.521-5.5-15.229-2.7-2.741-8.829,4.616-8.829,4.616",
    transform: "translate(-3865.989 -574.968)",
    fill: "#365da4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1592",
    "data-name": "Trazado 1592",
    d: "M4326.452,277.375c-.437-3.57.678-9.282,7.8-8.369s9.371,7.915,7.934,11.029,2.069,3.864,3.169,7.212c.945,2.876,1.274,6.447,2.8,8.05,4.932,5.167-4.735,13.113-10.563,11.438-10.616-3.052-11.983-3.508-11.607-11.849.193-4.274,3.519-5.93,1.407-7.166-5.1-2.987.042-2.267-.947-10.345",
    transform: "translate(-3831.346 -238.209)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1593",
    "data-name": "Trazado 1593",
    d: "M4357.925,370.179s.811,4.714-2.124,6.938l2.112,3.164,4.241-.208,1.959-5.07s-.6-.118-.888-6.438Z",
    transform: "translate(-3858.537 -326.489)",
    fill: "#a86337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1594",
    "data-name": "Trazado 1594",
    d: "M4353.735,304.57s6.346,1.274,7.079-2.69,2.046-6.47-1.976-7.451-5.09.385-5.656,1.649-1.079,8.058.553,8.492",
    transform: "translate(-3855.733 -260.52)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1595",
    "data-name": "Trazado 1595",
    d: "M4320.461,420.246c.273,0,5.266-1.67,12.395,1.233,0,0-3.385,19.363-1.931,23.059a39.042,39.042,0,0,1,2.007,6.975l-15.771.2s.22-12.684-.507-17.174,3.808-14.289,3.808-14.289",
    transform: "translate(-3823.789 -371.846)",
    fill: "#a86337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1596",
    "data-name": "Trazado 1596",
    d: "M4158,445.777a6.617,6.617,0,0,1-.182-.979,15.1,15.1,0,0,1,.731-6.112.011.011,0,0,0,0-.006l.028-.089c.016-.049.035-.125.059-.222a.039.039,0,0,0,0-.007c.023-.089.048-.2.076-.317.009-.04.018-.082.027-.128.406-1.818,1.3-6.384,1.532-7.006a6.083,6.083,0,0,0,.242-1c.238-1.375.343-3.562-.459-4.476-1.116-1.272-5.06-2.215-5.06-2.215-.779,1.221-3.3,4.237-6.615,3.691-1.914-.316-2.209-4.04-2.209-4.04a8.336,8.336,0,0,0-2.583.6s-4.93,3.076-11.9,12.871c-.221.312-.747.276-2.033.026-1.638-.319-4.979-.278-10.022-1.018,0,0-.174.126-.221.677a8.156,8.156,0,0,1-.226,1.578,62.868,62.868,0,0,0,6.851,2.683c1.25.4,2.556.767,3.8,1.045a19.507,19.507,0,0,0,3.233.485,23.253,23.253,0,0,0,7.924-5.843c.227,3.607.73,8.265.422,11.666-.177,1.937-1.5,8.453-1.169,9.537.692,2.259,6.013,2.376,10.764,2.14.1,0,.207-.01.311-.017.736-.042,1.46-.107,2.135-.182a29.36,29.36,0,0,0,3.095-.493,14.991,14.991,0,0,0,3.038-.974,3.233,3.233,0,0,0,1.587-1.345c-.457-2.458-2.658-7.812-3.187-10.527",
    transform: "translate(-3648.939 -374.596)",
    fill: "#80bdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1597",
    "data-name": "Trazado 1597",
    d: "M4389.438,287.017s-.112,1.345,1.976,3.626,1.59,6.349,1.59,6.349,3.518-6.612,1.641-8.723-5.207-1.253-5.207-1.253",
    transform: "translate(-3888.333 -254.097)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1598",
    "data-name": "Trazado 1598",
    d: "M4355.338,271.677s-3.155-1.056-6.286,2.029c-1.349,1.329-1.145,3.942-.422,5.458,0,0,1.109-3.249,3.129-3.957s3.58-3.53,3.58-3.53",
    transform: "translate(-3851.682 -240.507)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1599",
    "data-name": "Trazado 1599",
    d: "M4361.9,364.9s-.17.471-1.364.257c0,0-1-.179-.911-.707a3.271,3.271,0,0,1,2.275.45",
    transform: "translate(-3861.915 -322.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1600",
    "data-name": "Trazado 1600",
    d: "M4344.054,485.46c.9,3.053,1.423,5.566,3.684,7.264.736-.043,1.46-.107,2.135-.182a29.448,29.448,0,0,0,3.095-.493,14.993,14.993,0,0,0,3.038-.974,3.233,3.233,0,0,0,1.587-1.345c-.458-2.458-2.658-7.812-3.188-10.527a6.565,6.565,0,0,1-.1-.712,17.728,17.728,0,0,1,.655-6.379.009.009,0,0,0,0-.006c.029-.1.059-.207.088-.311a.041.041,0,0,0,0-.008c.019-.067.044-.176.075-.317.009-.04.019-.082.028-.128.362-1.722,1.312-7.127,1.553-7.833.077-.223-.1-1.223-.029-1.694l-1.633-1.209s-10.9,4.652-13.295,11.07,1.016,9.406,2.308,13.785",
    transform: "translate(-3845.348 -408.022)",
    fill: "#5f9aa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1601",
    "data-name": "Trazado 1601",
    d: "M4179.208,528.17a30.5,30.5,0,0,0,7.035,1.531,23.28,23.28,0,0,0,8-5.928c.166-.741.325-1.985-.573-1.626-1.259.5-5.917,6.484-7.68,6.61a54.762,54.762,0,0,1-6.783-.586",
    transform: "translate(-3702.105 -462.481)",
    fill: "#5f9aa8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1602",
    "data-name": "Trazado 1602",
    d: "M4254.581,452.364a55.905,55.905,0,0,0,10.026,3.814,20.879,20.879,0,0,0,3.732.6,16.7,16.7,0,0,0,8.828-6.893c6.421-9.884,1.683-11.455,1.683-11.455s-4.931,3.076-11.9,12.871c-.244.343-.856.265-2.44-.055-1.692-.342-5.06-.3-9.709-.984a2.583,2.583,0,0,0-.125.724c-.1,1.217-.1,1.377-.1,1.377",
    transform: "translate(-3768.873 -388.379)",
    fill: "#80bdcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1603",
    "data-name": "Trazado 1603",
    d: "M4087.453,524.351c-1.621-.316-5.068-.341-10.028-1.059a8.626,8.626,0,0,1-1.23-.488c-1.063-.532-3.9-.886-4.5-.319s.638,2.87,3.224,2.94a16.576,16.576,0,0,1,2.087.171,62.791,62.791,0,0,0,6.83,2.673c1.25.4,2.556.767,3.8,1.045a9.174,9.174,0,0,0-.185-4.965",
    transform: "translate(-3606.732 -462.582)",
    fill: "#a86337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1604",
    "data-name": "Trazado 1604",
    d: "M4212.86,536.183a5.481,5.481,0,0,1-.093-4.931c-1.691-.342-5.083-.49-9.733-1.173v.008a10.334,10.334,0,0,1-1.905-.692c-1.135-.567-4.16-.945-4.8-.34s.681,3.063,3.441,3.139a13.938,13.938,0,0,1,2.976.332,64.492,64.492,0,0,0,10.118,3.657",
    transform: "translate(-3717.125 -468.384)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2606",
    "data-name": "Rect\\xE1ngulo 2606",
    width: 21.814,
    height: 21.814,
    transform: "translate(108.654 111.652)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2607",
    "data-name": "Rect\\xE1ngulo 2607",
    width: 21.814,
    height: 21.814,
    transform: "translate(115.38 111.652)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1605",
    "data-name": "Trazado 1605",
    d: "M958.486,978.018,951.76,982.1v-4.078Z",
    transform: "translate(-843.106 -866.366)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1606",
    "data-name": "Trazado 1606",
    d: "M981.845,1073.669h-8.457l.355-.988-.355-1.067h8.377l-.514,1.107Z",
    transform: "translate(-862.266 -949.277)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1607",
    "data-name": "Trazado 1607",
    d: "M977.617,1071.615v2.055h-4.228l.355-.988-.355-1.067Z",
    transform: "translate(-862.266 -949.277)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2608",
    "data-name": "Rect\\xE1ngulo 2608",
    width: 12.544,
    height: 12.544,
    transform: "translate(109.965 99.109)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2609",
    "data-name": "Rect\\xE1ngulo 2609",
    width: 12.544,
    height: 12.544,
    transform: "translate(113.833 99.109)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1608",
    "data-name": "Trazado 1608",
    d: "M967.108,868.147l-3.868,2.345v-2.345Z",
    transform: "translate(-853.275 -769.038)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2610",
    "data-name": "Rect\\xE1ngulo 2610",
    width: 9.879,
    height: 9.879,
    transform: "translate(118.801 101.773)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2611",
    "data-name": "Rect\\xE1ngulo 2611",
    width: 9.879,
    height: 9.879,
    transform: "translate(121.847 101.773)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2612",
    "data-name": "Rect\\xE1ngulo 2612",
    width: 3.738,
    height: 1.9,
    transform: "translate(122.641 109.282) rotate(-11.294)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1609",
    "data-name": "Trazado 1609",
    d: "M1055.2,906.811h-3.569l.15-.417-.15-.451h3.536l-.217.467Z",
    transform: "translate(-931.572 -802.519)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1610",
    "data-name": "Trazado 1610",
    d: "M1053.412,905.944v.867h-1.785l.15-.417-.15-.45Z",
    transform: "translate(-931.572 -802.52)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1611",
    "data-name": "Trazado 1611",
    d: "M982.879,883.965h-4.218l.177-.493-.177-.532h4.179l-.256.552Z",
    transform: "translate(-866.936 -782.142)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1612",
    "data-name": "Trazado 1612",
    d: "M980.769,882.94v1.025H978.66l.177-.493-.177-.532Z",
    transform: "translate(-866.935 -782.143)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1613",
    "data-name": "Trazado 1613",
    d: "M982.879,950.323h-4.218l.177-.493-.177-.532h4.179l-.256.552Z",
    transform: "translate(-866.936 -840.924)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1614",
    "data-name": "Trazado 1614",
    d: "M980.769,949.3v1.025H978.66l.177-.493-.177-.532Z",
    transform: "translate(-866.935 -840.924)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2613",
    "data-name": "Rect\\xE1ngulo 2613",
    width: 17.354,
    height: 17.354,
    transform: "translate(127.199 116.112)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2614",
    "data-name": "Rect\\xE1ngulo 2614",
    width: 17.354,
    height: 17.354,
    transform: "translate(132.55 116.112)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2615",
    "data-name": "Rect\\xE1ngulo 2615",
    width: 4.239,
    height: 2.154,
    transform: "translate(144.31 117.986) rotate(-11.293)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1615",
    "data-name": "Trazado 1615",
    d: "M1144.762,1032.29h-4.7l.2-.55-.2-.594h4.66l-.286.615Z",
    transform: "translate(-1009.908 -913.43)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1616",
    "data-name": "Trazado 1616",
    d: "M1142.411,1031.148v1.143h-2.352l.2-.549-.2-.594Z",
    transform: "translate(-1009.908 -913.43)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1617",
    "data-name": "Trazado 1617",
    d: "M1144.762,1145.523h-4.7l.2-.549-.2-.594h4.66l-.286.615Z",
    transform: "translate(-1009.908 -1013.736)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1618",
    "data-name": "Trazado 1618",
    d: "M1142.411,1144.38v1.143h-2.352l.2-.549-.2-.594Z",
    transform: "translate(-1009.908 -1013.736)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1619",
    "data-name": "Trazado 1619",
    d: "M881.075,1202.3a2.383,2.383,0,1,0,2.383,2.382,2.383,2.383,0,0,0-2.383-2.382",
    transform: "translate(-778.38 -1065.041)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1620",
    "data-name": "Trazado 1620",
    d: "M887.7,1209.595a1.529,1.529,0,1,0,1.529,1.529,1.529,1.529,0,0,0-1.529-1.529",
    transform: "translate(-785.006 -1071.506)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1621",
    "data-name": "Trazado 1621",
    d: "M1301.109,1202.3a2.383,2.383,0,1,0,2.383,2.382,2.383,2.383,0,0,0-2.383-2.382",
    transform: "translate(-1150.463 -1065.041)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1622",
    "data-name": "Trazado 1622",
    d: "M1307.734,1209.595a1.529,1.529,0,1,0,1.529,1.529,1.529,1.529,0,0,0-1.529-1.529",
    transform: "translate(-1157.087 -1071.506)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1623",
    "data-name": "Trazado 1623",
    d: "M764.653,748.337H715.917l-19.453-53.129a1.263,1.263,0,0,0-1.134-.827l-6.486-.267a1.262,1.262,0,0,0-.1,2.523l5.643.232,18.845,51.468h-4.237a1.224,1.224,0,0,0-1.221,1.221v1.457a1.224,1.224,0,0,0,1.221,1.221h55.662a1.224,1.224,0,0,0,1.221-1.221v-1.457a1.224,1.224,0,0,0-1.221-1.221",
    transform: "translate(-609.041 -614.872)",
    fill: "#1c468a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1624",
    "data-name": "Trazado 1624",
    d: "M675.188,660.254a10.78,10.78,0,0,0,4.3,1.671c1.868.072,2.982,1.941,3.239,2.72s-.486,1.975-1.061,1.266c-.87-1.072-2.648-.236-4.345-1.638a16.423,16.423,0,0,0-4.231-2.3Z",
    transform: "translate(-596.244 -584.878)",
    fill: "#9e6138"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1625",
    "data-name": "Trazado 1625",
    d: "M501.895,400.9s5.214,18.649,9.373,22.415c2.158,1.954,14.107,9.924,15.091,7.381,0,0,1.476-1.8.656-2.871,0,0-10.044-7.224-10.826-7.71-1.362-.846.315-17.779-3.252-20.7s-9.052-3.671-11.042,1.479",
    transform: "translate(-444.598 -351.794)",
    fill: "#d88029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1626",
    "data-name": "Trazado 1626",
    d: "M593.85,1196.468s-.389.014-1.025.032H582.98a1.747,1.747,0,0,1-.469-.1c-.885-.421-.476-4.322-.476-4.322s3.83-3.191,4.412-.819,3.766,3.38,5.572,3.636,1.831,1.57,1.831,1.57",
    transform: "translate(-515.505 -1054.489)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1627",
    "data-name": "Trazado 1627",
    d: "M391.947,697.8c1.895,3.866,6.387,9.251,8.044,13.423a7.677,7.677,0,0,1,.629,2.72c.039,9.364,10.2,27.828,10.2,27.828.969.627,5.106-.628,5.106-.628s-.479-4.1-2.854-18.281c-1.309-7.821-3.518-19.465-5.234-28.336-.442-2.285-.852-4.386-1.2-6.189-.763-3.891-1.263-6.4-1.263-6.4l-3.942.065-10.646.176s-4.418,4.237,1.16,15.622",
    transform: "translate(-344.703 -604.086)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1628",
    "data-name": "Trazado 1628",
    d: "M391.947,698.307c1.895,3.866,6.387,9.251,8.044,13.424,2.348-4.969,5.912-12.523,7.851-16.7-.442-2.285-.852-4.385-1.2-6.189-1.531-1.875-3.5-4.278-5.2-6.335l-10.646.176s-4.418,4.237,1.16,15.622",
    transform: "translate(-344.703 -604.593)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1629",
    "data-name": "Trazado 1629",
    d: "M230.419,1167.714h-5.337a3.279,3.279,0,0,1-1.105-2c-.309-1.595-2.144-2.4-2.587-3.692s1.474-3.226,1.474-3.226l.644-.9,3.338.642a31.264,31.264,0,0,1,.315,4.077c-.025,1.755.639,3.615,2.209,3.892,1.142.2,1.137.867,1.049,1.215",
    transform: "translate(-196.057 -1025.703)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1630",
    "data-name": "Trazado 1630",
    d: "M257.629,716.913c-2,3.632-16.757,20.5-16.757,20.5s-4.651-1.571-5.479-4.4c0,0,8.728-14.341,12.7-20.453,1.135-1.748,1.766-28.461,5.81-33.329,5.071-6.1,14.25,5.476,14.25,5.476s-2.873,9.342-3.766,12.285c-1.979,6.526-5.378,17.416-6.756,19.919",
    transform: "translate(-208.52 -600.117)",
    fill: "#2b478b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1631",
    "data-name": "Trazado 1631",
    d: "M662.973,672.468a10.783,10.783,0,0,0,4.3,1.671c1.868.072,2.981,1.941,3.239,2.72s-.486,1.975-1.061,1.266c-.87-1.071-2.648-.236-4.345-1.638a16.427,16.427,0,0,0-4.231-2.3Z",
    transform: "translate(-585.424 -595.698)",
    fill: "#ab7041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1632",
    "data-name": "Trazado 1632",
    d: "M540.054,322.752a31.273,31.273,0,0,0,2.083-3.968l-3.439-6.032a10.842,10.842,0,0,1-6.63,6.928s5.409,5.935,9.765,6.235a9.971,9.971,0,0,0-1.78-3.162",
    transform: "translate(-471.326 -277.047)",
    fill: "#9c5f33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1633",
    "data-name": "Trazado 1633",
    d: "M584.841,273.26s-6.819-1.451-5.85-5.684.742-7.271,5.136-6.523,4.868,2.556,4.888,4.047-2.376,8.428-4.174,8.16",
    transform: "translate(-512.809 -231.15)",
    fill: "#ab7041"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1634",
    "data-name": "Trazado 1634",
    d: "M574.485,250.682a7.118,7.118,0,0,1,8.4-3.871c4.227.981,3.118-3.308,2.869-4.016,0,0-3.283-.617-6.678-1.159-7.127-1.137-4.974,7.977-4.593,9.046",
    transform: "translate(-508.369 -213.963)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1635",
    "data-name": "Trazado 1635",
    d: "M421.035,377.316a58.37,58.37,0,0,1-1.64,8.882c-.337,1.378-.707,2.809-1.1,4.249-.631,2.338-1.288,4.689-1.966,6.9l-.025.079c-.049.225-.125.464-.194.683-.588,1.954-1.152,3.764-1.643,5.3-.94,2.938-.947,4.574-1.7,4.906-1.508.667-7.447-.049-11.006-1.591-3.007-1.28-7.588-5.14-7.564-7.084.027-2.252,3.05-9.033,5.053-16.951,2.472-9.672,7.955-17.4,12.528-18.988.341-.111.706.606,2.032,1.879a7.423,7.423,0,0,0,4.227,2.064l.871,1.453a14.365,14.365,0,0,1,2.122,8.217",
    transform: "translate(-349.2 -322.171)",
    fill: "#e2923d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1636",
    "data-name": "Trazado 1636",
    d: "M531.806,492.659c-.337,1.378.389-1.441,0,0-.631,2.338-1.288,4.689-1.966,6.9l-.025.079c-.049.225-.125.464-.194.683-.588,1.954-1.152,3.764-1.643,5.3-9.51-12.08-4.117-26.547-4.117-26.547Z",
    transform: "translate(-462.706 -424.384)",
    fill: "#d88029"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1637",
    "data-name": "Trazado 1637",
    d: "M488.6,414.193s5.214,18.649,9.373,22.415c2.158,1.954,14.107,9.924,15.091,7.382,0,0,1.476-1.8.656-2.871,0,0-10.044-7.224-10.826-7.71-1.362-.846.315-17.779-3.252-20.7s-9.052-3.671-11.042,1.479",
    transform: "translate(-432.824 -363.568)",
    fill: "#e2923d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1638",
    "data-name": "Trazado 1638",
    d: "M582.909,287.081a3.7,3.7,0,0,1,2.812-1.474s-6.011.126-6.261,1.974-.316,2.139-.316,2.139,3.176.13,3.766-2.639",
    transform: "translate(-513.027 -253.001)",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1639",
    "data-name": "Trazado 1639",
    d: "M3815.371,462.822a64.985,64.985,0,0,1-6.851,2.659c-1.259.391-2.546.755-3.805,1.042a17.162,17.162,0,0,1-3.229.469,1.908,1.908,0,0,1-.236-.1,23.851,23.851,0,0,1-7.769-5.76c-.263-.312-.551-.626-.813-.964a24.692,24.692,0,0,1-.578-4.978l-.026-.027c-.184-2.841-.315-5.865-.315-5.865s4.567,1.226,11.129,12.278c.184.313.735.26,2.021.026,1.653-.313,4.987-.287,10.026-1.017,0,0,.184.13.236.678a6.916,6.916,0,0,0,.21,1.564",
    transform: "translate(-3358.879 -398.001)",
    fill: "#f4be61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1640",
    "data-name": "Trazado 1640",
    d: "M3803.9,512.6a23.847,23.847,0,0,1-7.769-5.76c-.263-.312-.551-.626-.814-.964a24.71,24.71,0,0,1-.577-4.978c.63.625,7.979,7.716,9.16,11.7",
    transform: "translate(-3361.526 -443.716)",
    fill: "#f2a83d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1641",
    "data-name": "Trazado 1641",
    d: "M3642.594,275.406s-.418-.85-2.508-.617-5.7.617-5.734,11.994c0,1.246-7.518,12.608.958,23.306l6.049-15.3Z",
    transform: "translate(-3216.726 -243.383)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1642",
    "data-name": "Trazado 1642",
    d: "M3703.9,279.9s-2.228-.747-3.4.36a2.329,2.329,0,0,0-.508,2.571Z",
    transform: "translate(-3277.426 -247.73)",
    fill: "#c65447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1643",
    "data-name": "Trazado 1643",
    d: "M3705.949,286.147s-.041-4.88-7.949-4.318a3.867,3.867,0,0,0-3.178,2.051c-.89,1.727-1.277,4.766,1.6,9.64Z",
    transform: "translate(-3272.44 -249.614)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1644",
    "data-name": "Trazado 1644",
    d: "M3709.644,391.539l1.782,6.918,5.149.25,2.562-3.814c-2.4-1.8-2.734-4.965-2.7-6.841,0-.018,0-.037,0-.055a10.923,10.923,0,0,1,.122-1.468l-3.653-1.1-2.782-.841a20.938,20.938,0,0,1,.123,4.7,5.1,5.1,0,0,1-.6,2.255",
    transform: "translate(-3286.146 -340.677)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1645",
    "data-name": "Trazado 1645",
    d: "M3659.271,477.577l18.682-.025s-2.325-12.44-1.034-16.517-.063-10.034-.063-10.034c-1.877-4.427-2.354-8.571-3.19-8.788-.458-.12-.828-.365-1.277-.455a24.187,24.187,0,0,0-13.305,1.2c-1.647,4.109,1.88,7.195,2.051,16.472a87.289,87.289,0,0,1-1.863,18.152",
    transform: "translate(-3240.971 -390.939)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1646",
    "data-name": "Trazado 1646",
    d: "M3663.421,480.443s-14.226,2.92-22.362-.1c-.446-.182,1.26-6.282,2.441-10.453a37.766,37.766,0,0,0,1-3.858c-.289-5.682-1.417-10.531-1.942-14.284a21.705,21.705,0,0,1-.289-2.711v-.417a6.89,6.89,0,0,1,.63-3.363c.892-1.642,5.7-1.669,5.7-1.669a9.564,9.564,0,0,0,6.168,2.32c3.123-.026,1.579-2.218,1.579-2.218.131.026.337.055.442.081a7.972,7.972,0,0,1,2.6,1.068c2.493,2.711,3.307,16.214,3.254,16.657-.1,1.642.788,18.95.788,18.95",
    transform: "translate(-3225.328 -392.944)",
    fill: "#f4be61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1647",
    "data-name": "Trazado 1647",
    d: "M3713.982,389.283a15.433,15.433,0,0,1,6.189-1.232h.076l-.075-.055c-.366-.268-2.009-1.469-3.531-2.573l-2.783-.841a20.891,20.891,0,0,1,.124,4.7",
    transform: "translate(-3289.88 -340.677)",
    fill: "#d68d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1648",
    "data-name": "Trazado 1648",
    d: "M3717.528,314.344s-7.849.356-8-4.5-1.261-8.084,3.744-8.517,6.036,1.392,6.482,3-.191,9.8-2.229,10.017",
    transform: "translate(-3285.862 -266.868)",
    fill: "#e49963"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1649",
    "data-name": "Trazado 1649",
    d: "M3741.844,296s3.361,2.3,2.823,4.959a3.462,3.462,0,0,0,1.508-3.408,5.074,5.074,0,0,0-4.742-4.416,24.9,24.9,0,0,0-3.764.04Z",
    transform: "translate(-3310.972 -259.628)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1650",
    "data-name": "Trazado 1650",
    d: "M3714.845,299.065c1.393.733-4.364,1.349-4.717,3.679s-3.1,3.222-3.1,3.222-3.482-12.842,7.813-6.9",
    transform: "translate(-3283.384 -263.533)",
    fill: "#163560"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1651",
    "data-name": "Trazado 1651",
    d: "M3671.28,499.386a27.091,27.091,0,0,1-17.847,9.54,37.846,37.846,0,0,0,1-3.858c-.289-5.682-1.417-10.531-1.942-14.284a21.691,21.691,0,0,1-.288-2.711v-.417c1.338.261,3.412,1.642,4.3,1.851,6.9,1.616,14.776,9.879,14.776,9.879",
    transform: "translate(-3235.26 -431.984)",
    fill: "#f2a83d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1652",
    "data-name": "Trazado 1652",
    d: "M3771.447,391.461s-.057.494-1.269.561c0,0-1.018.057-1.049-.475a3.293,3.293,0,0,1,2.318-.086",
    transform: "translate(-3338.841 -346.629)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1653",
    "data-name": "Trazado 1653",
    d: "M3676.06,465.829a56.117,56.117,0,0,1-10.026,3.788,21.03,21.03,0,0,1-3.731.6,18.894,18.894,0,0,1-8.829-6.846c-7.381-10.269-1.683-11.377-1.683-11.377s4.931,3.055,11.9,12.783c.244.34.855.263,2.44-.055,1.692-.339,5.06-.3,9.709-.977a2.559,2.559,0,0,1,.126.719c.1,1.209.1,1.367.1,1.367",
    transform: "translate(-3233.038 -400.391)",
    fill: "#f4be61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1654",
    "data-name": "Trazado 1654",
    d: "M3914.076,549.906a63.1,63.1,0,0,1-6.852,2.665c-1.249.394-2.555.761-3.8,1.038a9.052,9.052,0,0,1,.185-4.931c1.637-.317,5.137-.338,10.179-1.073Z",
    transform: "translate(-3457.581 -485.089)",
    fill: "#a86337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1655",
    "data-name": "Trazado 1655",
    d: "M3985.127,539.643a10.6,10.6,0,0,0,2.339-.774c1.063-.528,3.9-.88,4.5-.317s-.638,2.85-3.224,2.92a8.341,8.341,0,0,0-3.331.493Z",
    transform: "translate(-3530.18 -476.816)",
    fill: "#a86337"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1656",
    "data-name": "Trazado 1656",
    d: "M3802.992,555.7a65.125,65.125,0,0,1-10.15,3.647,5.41,5.41,0,0,0,.092-4.9c1.692-.339,5.084-.487,9.733-1.165,0,0,.055.359.1.907a6.85,6.85,0,0,0,.223,1.508",
    transform: "translate(-3359.847 -490.123)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1657",
    "data-name": "Trazado 1657",
    d: "M3191.816,759.089v-.182h-19.5a4.294,4.294,0,0,0-4.357,4.223,4.248,4.248,0,0,0,3.653,4.167v47.317h73.328V759.089Z",
    transform: "translate(-2806.301 -672.269)",
    fill: "#aa443e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2616",
    "data-name": "Rect\\xE1ngulo 2616",
    width: 11.714,
    height: 11.634,
    transform: "translate(444.891 57.652)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2617",
    "data-name": "Rect\\xE1ngulo 2617",
    width: 11.714,
    height: 11.634,
    transform: "translate(448.502 57.652)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1658",
    "data-name": "Trazado 1658",
    d: "M3900.65,505l-3.612,2.175V505Z",
    transform: "translate(-3452.147 -447.349)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1659",
    "data-name": "Trazado 1659",
    d: "M3915.376,519.672h-3.939l.165-.457-.165-.494h3.9l-.239.512Z",
    transform: "translate(-3464.903 -459.503)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1660",
    "data-name": "Trazado 1660",
    d: "M3913.407,518.722v.951h-1.969l.165-.457-.165-.494Z",
    transform: "translate(-3464.903 -459.504)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1661",
    "data-name": "Trazado 1661",
    d: "M3915.376,581.212h-3.939l.165-.457-.165-.494h3.9l-.239.512Z",
    transform: "translate(-3464.903 -514.017)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1662",
    "data-name": "Trazado 1662",
    d: "M3913.407,580.261v.95h-1.969l.165-.457-.165-.493Z",
    transform: "translate(-3464.903 -514.017)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1663",
    "data-name": "Trazado 1663",
    d: "M3873.744,543.159a11.326,11.326,0,0,0,2.5-.826c1.134-.564,4.16-.939,4.8-.338s-.681,3.043-3.442,3.118a8.907,8.907,0,0,0-3.555.526Z",
    transform: "translate(-3431.513 -479.849)",
    fill: "#b77446"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2618",
    "data-name": "Rect\\xE1ngulo 2618",
    width: 73.328,
    height: 55.525,
    transform: "translate(385.651 86.82)",
    fill: "#c65447"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1664",
    "data-name": "Trazado 1664",
    d: "M3276.092,758.907H3172.316a4.225,4.225,0,1,0,0,8.446h103.776c2.677,0,4.856-1.9,4.856-4.223s-2.179-4.223-4.856-4.223",
    transform: "translate(-2806.301 -672.269)",
    fill: "#e57970"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2619",
    "data-name": "Rect\\xE1ngulo 2619",
    width: 13.162,
    height: 11.695,
    transform: "translate(356.716 61.921)",
    fill: "#8cb3ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2620",
    "data-name": "Rect\\xE1ngulo 2620",
    width: 13.162,
    height: 11.695,
    transform: "translate(359.122 61.921)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2621",
    "data-name": "Rect\\xE1ngulo 2621",
    width: 16.583,
    height: 13.453,
    transform: "translate(373.612 60.163)",
    fill: "#8cb3ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2622",
    "data-name": "Rect\\xE1ngulo 2622",
    width: 16.583,
    height: 13.453,
    transform: "translate(376.642 60.163)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1665",
    "data-name": "Trazado 1665",
    d: "M3147.036,957.753s-5.459,4.06-6.524,3.814,3.99-4.383,3.99-4.383c-1.9-.915-7.814-.341-7.814-.341s-1.97,6.351-2.941,5.851,2.031-5.535,2.031-5.535a10.093,10.093,0,0,0-4.718,1.445c-3.557,2.809.234,7.232.234,7.232a10.812,10.812,0,0,1-2.976,4.177,9.387,9.387,0,0,0-3.431,6.612l.583.052s.933-3.988,2.627-5.844l.25-.255c.272-.252.462-.44.59-.581a8.527,8.527,0,0,1,2.548-1.926,1.053,1.053,0,0,1-.024-.28c.008.089.015.182.024.28.19,2.235,4.526,4.187,7.195,4.589s1.843-.7.923-2.321-3.828-2.354-4.492-3.1.708-.751,2.316-.016,1.828,2.692,4.406,3.926,6.458-3.044,6.458-3.044c-2.055-.1-4.99-2.336-4.883-3.019s4.981,1.178,5.814,1.267,2.729-.947,3.023-4.3-5.21-4.294-5.21-4.294",
    transform: "translate(-2768.146 -847.451)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1666",
    "data-name": "Trazado 1666",
    d: "M2893.275,867.1s6.031-3.377,3.216-7.96c0,0-2.251-2.814-4.664-3.538,0,0,1.287,6.834,0,7s-.884-7.719-.884-7.719-6.352-3.055-8.845-2.814c0,0,3.94,6.673,2.654,6.513s-5.709-6.915-5.709-6.915-6.513-1.206-7.558,2.654.643,5.789,1.608,6.03,7.156.161,7,.965-4.342,2.091-6.674,1.367c0,0,2.573,6.352,5.95,6.03s4.423-2.412,6.513-2.573,3.618.4,2.573.965-4.583.184-6.271,1.62-3.055,2.32.08,2.963,8.764.241,9.89-2.171Z",
    transform: "translate(-2543.381 -754.277)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1667",
    "data-name": "Trazado 1667",
    d: "M2920.526,904.3a12.833,12.833,0,0,1-1.608-5.87c-1.929-6.111-18.814-11.578-18.814-11.578,21.468,8.684,17.689,13.99,17.689,13.99.579.338,1.446,1.947,2.048,3.182.086.21.221.5.422.893.082.179.148.326.193.428,1.1,2.766.52,7.541.52,7.541l.67.18a11.136,11.136,0,0,0-1.12-8.768",
    transform: "translate(-2569.025 -785.609)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1668",
    "data-name": "Trazado 1668",
    d: "M3108.4,787.749s-7.949-4.452-4.24-10.493c0,0,2.968-3.709,6.147-4.663,0,0-1.7,9.009,0,9.221s1.166-10.175,1.166-10.175,8.373-4.028,11.659-3.71c0,0-5.193,8.8-3.5,8.585s7.525-9.115,7.525-9.115,8.584-1.59,9.962,3.5-.848,7.631-2.12,7.949-9.433.212-9.221,1.272,5.723,2.756,8.8,1.8c0,0-3.392,8.373-7.843,7.949s-5.829-3.18-8.584-3.392-4.77.53-3.392,1.272,6.041.243,8.267,2.135,4.027,3.058-.106,3.906-11.553.318-13.037-2.862Z",
    transform: "translate(-2748.911 -679.583)",
    fill: "#a8d29f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1669",
    "data-name": "Trazado 1669",
    d: "M3141.174,813.787s-22.258,7.207-24.8,15.262a16.9,16.9,0,0,1-2.12,7.737,14.679,14.679,0,0,0-1.476,11.557l.883-.237s-.772-6.3.685-9.941c.059-.134.146-.327.253-.562.266-.52.445-.9.558-1.181.793-1.627,1.937-3.749,2.7-4.194,0,0-4.981-7,23.317-18.442",
    transform: "translate(-2756.885 -720.884)",
    fill: "#82b378"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1670",
    "data-name": "Trazado 1670",
    d: "M3010.208,1100.617a15.571,15.571,0,1,0,31.142,0Z",
    transform: "translate(-2666.558 -974.969)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1671",
    "data-name": "Trazado 1671",
    d: "M3044.336,1116.068a15.581,15.581,0,0,1-17.5-15.452h3.869a15.573,15.573,0,0,0,13.636,15.452",
    transform: "translate(-2681.284 -974.968)",
    fill: "#ffb973"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1672",
    "data-name": "Trazado 1672",
    d: "M3037.976,1227.125h-27.73a1.921,1.921,0,0,0-1.921,1.921H3039.9a1.921,1.921,0,0,0-1.921-1.921",
    transform: "translate(-2664.891 -1087.034)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2623",
    "data-name": "Rect\\xE1ngulo 2623",
    width: 32.008,
    height: 0.478,
    transform: "translate(343.137 125.648)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1673",
    "data-name": "Trazado 1673",
    d: "M1708.4,746.605l-3.1-11.573a.824.824,0,0,0-1.008-.583l-19.252,5.149a.824.824,0,0,0-.583,1.008l3.1,11.573a.828.828,0,0,0,1.008.583l19.252-5.149a.828.828,0,0,0,.583-1.008",
    transform: "translate(-1492.135 -650.579)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1674",
    "data-name": "Trazado 1674",
    d: "M1705.3,735.032a.824.824,0,0,0-1.008-.583l-19.252,5.149a.824.824,0,0,0-.583,1.008l11.969,3,8.963-8.24Z",
    transform: "translate(-1492.135 -650.579)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1675",
    "data-name": "Trazado 1675",
    d: "M1848.889,834.563a.332.332,0,0,0-.405-.234l-3.611.966a.331.331,0,0,0,.171.64l3.611-.966a.332.332,0,0,0,.234-.406",
    transform: "translate(-1634.042 -739.07)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2624",
    "data-name": "Rect\\xE1ngulo 2624",
    width: 34.325,
    height: 34.325,
    transform: "translate(166.231 108.072)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2625",
    "data-name": "Rect\\xE1ngulo 2625",
    width: 34.325,
    height: 34.325,
    transform: "translate(176.815 108.072)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1676",
    "data-name": "Trazado 1676",
    d: "M1466.69,946.659l-10.584,6.416v-6.416Z",
    transform: "translate(-1289.875 -838.587)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1677",
    "data-name": "Trazado 1677",
    d: "M1503.446,1097.168h-13.307l.56-1.554-.56-1.679h13.182l-.808,1.741Z",
    transform: "translate(-1320.023 -969.05)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1678",
    "data-name": "Trazado 1678",
    d: "M1496.792,1093.935v3.234h-6.653l.559-1.555-.559-1.679Z",
    transform: "translate(-1320.023 -969.049)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2626",
    "data-name": "Rect\\xE1ngulo 2626",
    width: 19.739,
    height: 19.739,
    transform: "translate(240.089 122.272)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2627",
    "data-name": "Rect\\xE1ngulo 2627",
    width: 19.739,
    height: 19.739,
    transform: "translate(246.175 122.272)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1679",
    "data-name": "Trazado 1679",
    d: "M2109.153,1071.046l-6.086,3.69v-3.69Z",
    transform: "translate(-1862.978 -948.774)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2628",
    "data-name": "Rect\\xE1ngulo 2628",
    width: 15.545,
    height: 15.545,
    transform: "translate(253.992 126.465)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2629",
    "data-name": "Rect\\xE1ngulo 2629",
    width: 15.545,
    height: 15.545,
    transform: "translate(258.785 126.465)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2630",
    "data-name": "Rect\\xE1ngulo 2630",
    width: 5.882,
    height: 2.989,
    transform: "translate(260.035 138.28) rotate(-11.294)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1680",
    "data-name": "Trazado 1680",
    d: "M2247.764,1131.893h-5.617l.237-.656-.237-.709h5.564l-.341.735Z",
    transform: "translate(-1986.18 -1001.466)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1681",
    "data-name": "Trazado 1681",
    d: "M2244.955,1130.528v1.365h-2.808l.236-.656-.236-.709Z",
    transform: "translate(-1986.18 -1001.466)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1682",
    "data-name": "Trazado 1682",
    d: "M2133.97,1095.938h-6.638l.279-.776-.279-.838h6.576l-.4.869Z",
    transform: "translate(-1884.473 -969.395)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1683",
    "data-name": "Trazado 1683",
    d: "M2130.651,1094.325v1.613h-3.318l.279-.776-.279-.837Z",
    transform: "translate(-1884.474 -969.396)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1684",
    "data-name": "Trazado 1684",
    d: "M2133.97,1200.352h-6.638l.279-.775-.279-.837h6.576l-.4.868Z",
    transform: "translate(-1884.473 -1061.89)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1685",
    "data-name": "Trazado 1685",
    d: "M2130.651,1198.739v1.613h-3.318l.279-.775-.279-.837Z",
    transform: "translate(-1884.474 -1061.89)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2631",
    "data-name": "Rect\\xE1ngulo 2631",
    width: 27.307,
    height: 27.307,
    transform: "translate(195.491 115.203)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2632",
    "data-name": "Rect\\xE1ngulo 2632",
    width: 27.307,
    height: 27.307,
    transform: "translate(203.91 115.203)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2633",
    "data-name": "Rect\\xE1ngulo 2633",
    width: 6.671,
    height: 3.39,
    transform: "translate(222.415 118.152) rotate(-11.293)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1686",
    "data-name": "Trazado 1686",
    d: "M1760.49,1033.048h-7.4l.311-.865-.311-.934h7.332l-.45.969Z",
    transform: "translate(-1552.954 -913.52)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1687",
    "data-name": "Trazado 1687",
    d: "M1756.79,1031.249v1.8h-3.7l.311-.865-.311-.934Z",
    transform: "translate(-1552.954 -913.52)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1688",
    "data-name": "Trazado 1688",
    d: "M1760.49,1211.221h-7.4l.311-.865-.311-.934h7.332l-.45.969Z",
    transform: "translate(-1552.954 -1071.353)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1689",
    "data-name": "Trazado 1689",
    d: "M1756.79,1209.423v1.8h-3.7l.311-.865-.311-.934Z",
    transform: "translate(-1552.954 -1071.353)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1690",
    "data-name": "Trazado 1690",
    d: "M1617.045,725.657h-10.518l.442-1.229-.442-1.327h10.419l-.639,1.376Z",
    transform: "translate(-1423.124 -640.551)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1691",
    "data-name": "Trazado 1691",
    d: "M1611.785,723.1v2.556h-5.259l.442-1.229-.442-1.327Z",
    transform: "translate(-1423.123 -640.551)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2634",
    "data-name": "Rect\\xE1ngulo 2634",
    width: 54.607,
    height: 1.921,
    transform: "translate(354.772 16.632)",
    fill: "#91b6ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2635",
    "data-name": "Rect\\xE1ngulo 2635",
    width: 70.944,
    height: 1.921,
    transform: "translate(341.89 0.495)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2636",
    "data-name": "Rect\\xE1ngulo 2636",
    width: 54.607,
    height: 1.921,
    transform: "translate(354.772 35.628)",
    fill: "#91b6ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2637",
    "data-name": "Rect\\xE1ngulo 2637",
    width: 54.607,
    height: 1.921,
    transform: "translate(354.772 54.624)",
    fill: "#91b6ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2638",
    "data-name": "Rect\\xE1ngulo 2638",
    width: 54.607,
    height: 1.921,
    transform: "translate(354.772 73.62)",
    fill: "#91b6ed"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2639",
    "data-name": "Rect\\xE1ngulo 2639",
    width: 15.501,
    height: 15.501,
    transform: "translate(356.657 20.127)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2640",
    "data-name": "Rect\\xE1ngulo 2640",
    width: 15.501,
    height: 15.501,
    transform: "translate(361.436 20.127)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1692",
    "data-name": "Trazado 1692",
    d: "M3128.929,176.3l-4.78,2.9v-2.9Z",
    transform: "translate(-2767.493 -156.173)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2641",
    "data-name": "Rect\\xE1ngulo 2641",
    width: 12.207,
    height: 12.207,
    transform: "translate(367.576 23.421)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2642",
    "data-name": "Rect\\xE1ngulo 2642",
    width: 12.207,
    height: 12.207,
    transform: "translate(371.34 23.421)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2643",
    "data-name": "Rect\\xE1ngulo 2643",
    width: 4.619,
    height: 2.348,
    transform: "matrix(0.981, -0.196, 0.196, 0.981, 372.321, 32.759)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1693",
    "data-name": "Trazado 1693",
    d: "M3237.782,224.616h-4.411l.186-.515-.186-.557h4.37l-.268.577Z",
    transform: "translate(-2864.245 -198.023)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1694",
    "data-name": "Trazado 1694",
    d: "M3235.577,223.544v1.072h-2.205l.186-.515-.186-.557Z",
    transform: "translate(-2864.246 -198.024)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1695",
    "data-name": "Trazado 1695",
    d: "M3148.419,195.595h-5.213l.219-.609-.219-.658h5.164l-.316.682Z",
    transform: "translate(-2784.374 -172.143)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1696",
    "data-name": "Trazado 1696",
    d: "M3145.813,194.328v1.267h-2.606l.219-.609-.219-.658Z",
    transform: "translate(-2784.374 -172.143)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1697",
    "data-name": "Trazado 1697",
    d: "M3148.419,277.591h-5.213l.219-.609-.219-.658h5.164l-.316.682Z",
    transform: "translate(-2784.374 -244.779)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1698",
    "data-name": "Trazado 1698",
    d: "M3145.813,276.325v1.267h-2.606l.219-.609-.219-.658Z",
    transform: "translate(-2784.374 -244.779)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2644",
    "data-name": "Rect\\xE1ngulo 2644",
    width: 12.208,
    height: 12.207,
    transform: "translate(364.185 4.452)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2645",
    "data-name": "Rect\\xE1ngulo 2645",
    width: 12.208,
    height: 12.207,
    transform: "translate(367.949 4.452)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2646",
    "data-name": "Rect\\xE1ngulo 2646",
    width: 4.619,
    height: 2.348,
    transform: "matrix(0.981, -0.196, 0.196, 0.981, 368.931, 13.731)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1699",
    "data-name": "Trazado 1699",
    d: "M3208.085,57.937h-4.411l.186-.515-.186-.557h4.37l-.268.577Z",
    transform: "translate(-2837.939 -50.373)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1700",
    "data-name": "Trazado 1700",
    d: "M3205.881,56.865v1.072h-2.205l.185-.515-.185-.557Z",
    transform: "translate(-2837.94 -50.373)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2647",
    "data-name": "Rect\\xE1ngulo 2647",
    width: 8.626,
    height: 8.626,
    transform: "translate(381.778 8.004)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2648",
    "data-name": "Rect\\xE1ngulo 2648",
    width: 8.626,
    height: 8.626,
    transform: "translate(384.438 8.004)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1701",
    "data-name": "Trazado 1701",
    d: "M3346.859,70.1l-2.66,1.613V70.1Z",
    transform: "translate(-2962.422 -62.101)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1702",
    "data-name": "Trazado 1702",
    d: "M3357.7,80.983h-2.9l.122-.339-.122-.366h2.874l-.177.379Z",
    transform: "translate(-2971.815 -71.113)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1703",
    "data-name": "Trazado 1703",
    d: "M3356.253,80.277v.7h-1.45l.122-.339-.122-.366Z",
    transform: "translate(-2971.815 -71.113)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1704",
    "data-name": "Trazado 1704",
    d: "M3357.7,126.613h-2.9l.122-.339-.122-.366h2.874l-.177.38Z",
    transform: "translate(-2971.815 -111.534)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1705",
    "data-name": "Trazado 1705",
    d: "M3356.253,125.907v.7h-1.45l.122-.339-.122-.366Z",
    transform: "translate(-2971.815 -111.533)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2649",
    "data-name": "Rect\\xE1ngulo 2649",
    width: 10.142,
    height: 10.142,
    transform: "translate(356.803 44.489)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2650",
    "data-name": "Rect\\xE1ngulo 2650",
    width: 10.142,
    height: 10.142,
    transform: "translate(359.93 44.489)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2651",
    "data-name": "Rect\\xE1ngulo 2651",
    width: 3.838,
    height: 1.95,
    transform: "matrix(0.981, -0.196, 0.196, 0.981, 360.745, 52.198)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1706",
    "data-name": "Trazado 1706",
    d: "M3140.374,405.44h-3.665l.154-.428-.154-.462h3.63l-.223.479Z",
    transform: "translate(-2778.619 -358.365)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1707",
    "data-name": "Trazado 1707",
    d: "M3138.542,404.549v.89h-1.832l.153-.428-.153-.462Z",
    transform: "translate(-2778.62 -358.365)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2652",
    "data-name": "Rect\\xE1ngulo 2652",
    width: 10.142,
    height: 10.142,
    transform: "translate(371.301 44.489)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2653",
    "data-name": "Rect\\xE1ngulo 2653",
    width: 10.142,
    height: 10.142,
    transform: "translate(374.429 44.489)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2654",
    "data-name": "Rect\\xE1ngulo 2654",
    width: 3.838,
    height: 1.95,
    transform: "matrix(0.981, -0.196, 0.196, 0.981, 375.244, 52.198)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1708",
    "data-name": "Trazado 1708",
    d: "M3267.374,405.44h-3.664l.154-.428-.154-.462h3.63l-.222.479Z",
    transform: "translate(-2891.121 -358.365)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1709",
    "data-name": "Trazado 1709",
    d: "M3265.542,404.549v.89h-1.832l.154-.428-.154-.462Z",
    transform: "translate(-2891.121 -358.365)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2655",
    "data-name": "Rect\\xE1ngulo 2655",
    width: 7.396,
    height: 7.396,
    transform: "translate(385.042 28.232)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2656",
    "data-name": "Rect\\xE1ngulo 2656",
    width: 7.397,
    height: 7.396,
    transform: "translate(387.323 28.232)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1710",
    "data-name": "Trazado 1710",
    d: "M3375.073,247.293l-2.281,1.383v-1.383Z",
    transform: "translate(-2987.75 -219.062)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2657",
    "data-name": "Rect\\xE1ngulo 2657",
    width: 5.825,
    height: 5.825,
    transform: "translate(390.252 29.803)",
    fill: "#4a75cb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2658",
    "data-name": "Rect\\xE1ngulo 2658",
    width: 5.825,
    height: 5.825,
    transform: "translate(392.048 29.803)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2659",
    "data-name": "Rect\\xE1ngulo 2659",
    width: 2.204,
    height: 1.12,
    transform: "translate(392.516 34.29) rotate(-11.292)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1711",
    "data-name": "Trazado 1711",
    d: "M3427.011,270.621h-2.1l.088-.246-.088-.266h2.085l-.128.275Z",
    transform: "translate(-3033.915 -239.274)",
    fill: "#ebf2f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1712",
    "data-name": "Trazado 1712",
    d: "M3425.959,270.11v.511h-1.052l.088-.246-.088-.266Z",
    transform: "translate(-3033.916 -239.273)",
    fill: "#a6c7f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1713",
    "data-name": "Trazado 1713",
    d: "M3384.371,256.773h-2.487l.1-.291-.1-.314h2.464l-.151.326Z",
    transform: "translate(-2995.804 -226.924)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1714",
    "data-name": "Trazado 1714",
    d: "M3383.128,256.169v.6h-1.244l.1-.291-.1-.314Z",
    transform: "translate(-2995.804 -226.924)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1715",
    "data-name": "Trazado 1715",
    d: "M3384.371,295.9h-2.487l.1-.291-.1-.314h2.464l-.151.325Z",
    transform: "translate(-2995.804 -261.584)",
    fill: "#ffd5ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1716",
    "data-name": "Trazado 1716",
    d: "M3383.128,295.295v.6h-1.244l.1-.291-.1-.314Z",
    transform: "translate(-2995.804 -261.583)",
    fill: "#c95c12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1717",
    "data-name": "Trazado 1717",
    d: "M3493.569,360.319l-3.116,13.533h8.611l3.117-13.533Z",
    transform: "translate(-3091.978 -319.185)",
    fill: "#699dee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1718",
    "data-name": "Trazado 1718",
    d: "M3444.716,360.319l-3.117,13.533h8.612l3.117-13.533Z",
    transform: "translate(-3048.701 -319.185)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1719",
    "data-name": "Trazado 1719",
    d: "M3407.557,420.625l0,5.88a.406.406,0,0,1-.4.4l-9.78.007a.407.407,0,0,1-.4-.4l0-5.88a.4.4,0,0,1,.4-.4l9.781-.007a.4.4,0,0,1,.4.4",
    transform: "translate(-3009.166 -372.248)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1720",
    "data-name": "Trazado 1720",
    d: "M3407.557,420.625v.17l-5.292,2.773-5.3-2.936a.4.4,0,0,1,.4-.4l9.781-.007a.4.4,0,0,1,.4.4",
    transform: "translate(-3009.166 -372.248)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1721",
    "data-name": "Trazado 1721",
    d: "M3467.546,470.051h-1.834a.163.163,0,1,0,0,.325h1.834a.163.163,0,1,0,0-.325",
    transform: "translate(-3069.918 -416.389)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1722",
    "data-name": "Trazado 1722",
    d: "M3391.752,420.244a.4.4,0,0,0-.4-.4l-9.781.007a.4.4,0,0,0-.4.4l0,5.88a.406.406,0,0,0,.4.4l9.781-.007a.406.406,0,0,0,.4-.4Z",
    transform: "translate(-2995.166 -371.91)",
    fill: "#f1a34f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1723",
    "data-name": "Trazado 1723",
    d: "M3391.752,420.244v.17l-5.292,2.773-5.3-2.936a.4.4,0,0,1,.4-.4l9.78-.007a.4.4,0,0,1,.4.4",
    transform: "translate(-2995.166 -371.91)",
    fill: "#d86713"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1724",
    "data-name": "Trazado 1724",
    d: "M3451.741,469.668h-1.834a.163.163,0,1,0,0,.325h1.834a.163.163,0,1,0,0-.325",
    transform: "translate(-3055.917 -416.05)",
    fill: "#d86713"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooter);
export default __webpack_public_path__ + "static/media/footer.89b0560d.svg";
export { ForwardRef as ReactComponent };